<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="row">
      <div class="col-xl-12">
        <div class="dash-head-wrap d-flex justify-content-between align-items-center">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">
              Learning Hub <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="" />
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card top-cardheader">
      <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
        <h5 class="font-weight-normal text-default m-0">Course Overview</h5>
      </div>
      <div class="row m-0">
        <div class="col-xl-3 col-md-6 p-0" @click="showOpen" style="cursor: pointer">
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="courseStatusIcons.open" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Total Employee">Open Courses</h5>
                <span name="Total Employee">{{tableData.filter((data) => data.course_status === 2).length}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6 p-0" @click="showPassed" style="cursor: pointer">
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="courseStatusIcons.passed" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="New employee">Passed Courses</h5>
                <span name="New employee">{{tableData.filter((data) => data.course_status === 1).length}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6 p-0" @click="showFailed" style="cursor: pointer">
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="courseStatusIcons.failed" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Active Employee">
                  Failed Courses
                </h5>
                <span name="Active Employee">{{tableData.filter((data) => data.course_status === 0).length}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-md-6 p-0" @click="showExpired" style="cursor: pointer">
          <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="courseStatusIcons.expired" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0">Overdue Courses</h5>
                <span>{{tableData.filter((data) => data.course_status === 3).length}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <card class="no-border-card" body-classes="" footer-classes="pb-2">

      <div class="row justify-content-sm-between flex-wrap location-form mb-4">
        <div class="col-md-6 col-lg-6 d-flex align-items-center search-style">
          <h2 class="mb-0" v-if="is_open_show">Open Courses</h2>
          <h2 class="mb-0" v-if="is_expired">Overdue Courses</h2>
          <h2 class="mb-0" v-if="is_failed">Failed Courses</h2>
          <h2 class="mb-0" v-if="is_passed">Passed Courses</h2>
        </div>
        <div class="col-md-6 col-lg-6 d-flex justify-content-end search-style" v-if="isPurchaseCourseVisible">
          <base-button v-if="isSafeDig" type="primary" @click.prevent="openSafeDigAddCourseModal">
            Add New Course
          </base-button>
          <base-button v-else name="Pay Course" type="primary" @click.prevent="purchaseModal()">
            Purchase New Course
          </base-button>
        </div>
      </div>

      <span v-if="openCourses > 0">
        <div class="grid-action-boxes">
          <div class="row">
            <div v-if="is_open_show" class="col-md-4 mb-4"
              v-for="course in tableData.filter((data) => data.course_status === 2)" :key="course.id">
              <span v-if="tableData.filter((data) => data.course_status === 2).length > 0">
                <div class="grid-wrap border rounded p-3">
                  <span class="img-wrap position-relative">
                    <img class="d-block mx-auto w-100 mb-3" :src="course.img ? course.img : '/placeholder.jpg'"
                      style="height: 200px; object-fit: cover" />
                    <a class="play-btn" href="#" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                      @click.prevent="PayCourse(course)">
                      <img :src="playIcon" alt="" />
                    </a>
                    <a class="play-btn" href="#" v-else @click.prevent="
                      takingCourse(course.id, course.due_date, course.is_2fa_required, playbtn = true)
                      ">
                      <img :src="playIcon" alt="" />
                    </a>
                  </span>
                  <div class="grid-header d-flex justify-content-between">
                    <h5 class="mb-4">{{ course.course_name }}</h5>
                  </div>

                  <div class="progress-area mb-4">
                    <div class="progress-top-row d-flex justify-content-between">
                      <span class="assigned">Due Date : {{ course.due_date }}</span>
                      <span class="time">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                            fill="#787878" />
                        </svg>

                        {{ course.course_length }} minutes
                      </span>
                    </div>
                  </div>
                  <div class="action-area d-flex justify-content-between">
                    <base-button name="Pay Course" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                      @click.prevent="PayCourse(course)" type="primary" outline="true" class="px-3 py-2 w-100">
                      {{ "Pay" }}
                    </base-button>
                    <base-button type="primary" outline="true" class="px-3 py-2 w-100" name="Take Course" v-else
                      @click.prevent="
                        takingCourse(course.id, course.due_date, course.is_2fa_required, playbtn = false)
                        ">
                      {{
                        course.course_attempts !== undefined &&
                          course.course_attempts.length > 0
                          ? "Retake Course "
                          : "Take Course"
                      }}
                    </base-button>
                  </div>
                </div>
              </span>
              <span v-else>
                <div class="grid-wrap border rounded p-3">
                  <img :src="emptySlotIcon" alt="No data available" class="w-100"
                    style="max-width: 300px; margin: 0 auto; display: block" />
                </div>
              </span>
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <span v-if="is_open_show">
          <div class="grid-wrap border rounded p-3">
            <img :src="emptySlotIcon" alt="No data available" class="w-100"
              style="max-width: 300px; margin: 0 auto; display: block" />
          </div>
        </span>
      </span>
      <br />
      <span v-if="expiredCourses > 0">
        <div class="grid-action-boxes">
          <div class="row">
            <div v-if="is_expired" class="col-md-4 mb-4"
              v-for="course in tableData.filter((data) => data.course_status === 3)" :key="course.id">
              <span v-if="tableData.filter((data) => data.course_status === 3).length > 0">
                <div class="grid-wrap border rounded p-3">
                  <span class="img-wrap position-relative">
                    <img class="d-block mx-auto w-100 mb-3" :src="course.img ? course.img : '/placeholder.jpg'"
                      style="height: 200px; object-fit: cover" />
                    <a class="play-btn" href="#" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                      @click.prevent="PayCourse(course)">
                      <img :src="playIcon" alt="" />
                    </a>
                    <router-link class="play-btn" href="#" v-else :to="'/course_instructions?id=' +
                      course.id +
                      '&due_date=' +
                      course.due_date
                      ">
                      <img :src="playIcon" alt="" />
                    </router-link>
                  </span>
                  <div class="grid-header d-flex justify-content-between">
                    <h5 class="mb-4">{{ course.course_name }}</h5>
                  </div>
                  <div class="progress-area mb-4">
                    <div class="progress-top-row d-flex justify-content-between">
                      <span class="assigned">Due Date : {{ course.due_date }}</span>
                      <span class="time">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                            fill="#787878" />
                        </svg>

                        {{ course.course_length }} minutes
                      </span>
                    </div>
                  </div>
                  <div class="action-area d-flex justify-content-between">
                    <base-button name="Pay Course" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                      @click.prevent="PayCourse(course)" type="primary" outline="true" class="px-3 py-2 w-100">
                      {{ "Pay" }}
                    </base-button>
                    <router-link class="w-100" v-else :to="'/course_instructions?id=' +
                      course.id +
                      '&due_date=' +
                      course.due_date
                      ">
                      <base-button type="primary" outline="true" class="px-3 py-2 w-100" name="Take Course">
                        {{
                          course.course_attempts !== undefined &&
                            course.course_attempts.length > 0
                            ? "Retake Course "
                            : "Take Course"
                        }}
                      </base-button>
                    </router-link>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <span v-if="is_expired">
          <div class="grid-wrap border rounded p-3">
            <img :src="emptySlotIcon" alt="No data available" class="w-100"
              style="max-width: 300px; margin: 0 auto; display: block" />
          </div>
        </span>
      </span>
      <span v-if="failedCourses > 0">
        <div class="grid-action-boxes">
          <div class="row">
            <div v-if="is_failed" class="col-md-4 mb-4"
              v-for="course in tableData.filter((data) => data.course_status === 0)" :key="course.id">
              <div class="grid-wrap border rounded p-3">
                <span class="img-wrap position-relative">
                  <img class="d-block mx-auto w-100 mb-3" :src="course.img ? course.img : '/placeholder.jpg'"
                    style="height: 200px; object-fit: cover" loading="lazy" />
                  <a class="play-btn" href="#" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                    @click.prevent="PayCourse(course)">
                    <img :src="playIcon" alt="" />
                  </a>
                  <a class="play-btn" href="#" v-else @click.prevent="
                    takingCourse(course.id, course.due_date, course.is_2fa_required, playbtn = true)
                    ">
                    <img :src="playIcon" alt="" />
                  </a>
                </span>
                <div class="grid-header d-flex justify-content-between">
                  <h5 class="mb-4">{{ course.course_name }}</h5>
                </div>
                <div class="progress-area mb-4">
                  <div class="progress-top-row d-flex justify-content-between">
                    <span class="assigned">Due Date :{{ course.due_date }}</span>
                    <span class="time">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                          fill="#787878" />
                      </svg>

                      {{ course.course_length }} minutes
                    </span>
                  </div>
                </div>
                <div class="action-area d-flex justify-content-between">
                  <base-button name="Pay Course" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                    @click.prevent="PayCourse(course)" type="primary" outline="true" class="px-3 py-2 w-100">
                    {{ "Pay" }}
                  </base-button>
                  <base-button type="primary" outline="true" class="px-3 py-2 w-100" name="Take Course" v-else
                    @click.prevent="
                      takingCourse(course.id, course.due_date, course.is_2fa_required, playbtn = false)
                      ">
                    {{
                      course.course_attempts !== undefined &&
                        course.course_attempts.length > 0
                        ? "Retake Course "
                        : "Take Course"
                    }}
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <span v-if="is_failed">
          <div class="grid-wrap border rounded p-3">
            <img :src="emptySlotIcon" alt="No data available" class="w-100"
              style="max-width: 300px; margin: 0 auto; display: block" />
          </div>
        </span>
      </span>
      <span v-if="passedCourses > 0">
        <div class="grid-action-boxes">
          <div class="row">
            <div v-if="is_passed" class="col-md-4 mb-4"
              v-for="course in tableData.filter((data) => data.course_status === 1)" :key="course.id">
              <div class="grid-wrap border rounded p-3">
                <span class="img-wrap position-relative">
                  <img class="d-block mx-auto w-100 mb-3" :src="course.img ? course.img : '/placeholder.jpg'"
                    style="height: 200px; object-fit: cover" loading="lazy" />
                </span>
                <div class="grid-header d-flex justify-content-between">
                  <h5 class="mb-4">{{ course.course_name }}</h5>
                </div>
                <div class="progress-area mb-4">
                  <div class="progress-top-row d-flex justify-content-between">
                    <span class="assigned">Completion Date : {{ course.completion_date }}</span>
                    <span class="time">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                          fill="#787878" />
                      </svg>

                      {{ course.course_length }} minutes
                    </span>
                  </div>
                  <div class="progress-top-row d-flex justify-content-between">
                    <span class="assigned">Due Date : {{ course.due_date }}</span>
                  </div>
                </div>
                <div class="action-area pass-action-area d-flex flex-wrap justify-content-between"
                  v-for="certificate in course.certificates" :key="certificate.id">
                  <base-button type="primary" outline="true" class="passed-btn mr-0 mb-3 mb-md-0 px-2"
                    v-if="certificate.manual == 0 && certificate.is_proctored_exam == 0" @click="
                      generatePreviewCertificate(
                        course.id,
                        user_id,
                        course.certificate_id,
                        certificate.is_coursefolder
                      )
                      ">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.888 6.98812C14.3393 5.78812 12.1874 1.875 7.49992 1.875C2.81242 1.875 0.660545 5.78812 0.111795 6.98812C0.0381309 7.14894 0 7.32374 0 7.50063C0 7.67751 0.0381309 7.85231 0.111795 8.01313C0.660545 9.21188 2.81242 13.125 7.49992 13.125C12.1874 13.125 14.3393 9.21188 14.888 8.01188C14.9616 7.85124 14.9996 7.67666 14.9996 7.5C14.9996 7.32334 14.9616 7.14876 14.888 6.98812ZM7.49992 11.875C3.55804 11.875 1.71867 8.52125 1.24992 7.50687C1.71867 6.47875 3.55804 3.125 7.49992 3.125C11.4324 3.125 13.2724 6.46438 13.7499 7.5C13.2724 8.53562 11.4324 11.875 7.49992 11.875Z"
                        :fill="passedButtonIconColor" />
                      <path
                        d="M7.5 4.375C6.88193 4.375 6.27775 4.55828 5.76384 4.90166C5.24994 5.24504 4.8494 5.7331 4.61288 6.30411C4.37635 6.87513 4.31447 7.50347 4.43505 8.10966C4.55563 8.71585 4.85325 9.27267 5.29029 9.70971C5.72733 10.1467 6.28415 10.4444 6.89034 10.565C7.49653 10.6855 8.12487 10.6236 8.69589 10.3871C9.26691 10.1506 9.75496 9.75006 10.0983 9.23616C10.4417 8.72225 10.625 8.11807 10.625 7.5C10.624 6.6715 10.2944 5.87722 9.70861 5.29139C9.12278 4.70555 8.3285 4.37599 7.5 4.375ZM7.5 9.375C7.12916 9.375 6.76665 9.26503 6.45831 9.05901C6.14996 8.85298 5.90964 8.56014 5.76773 8.21753C5.62581 7.87492 5.58868 7.49792 5.66103 7.13421C5.73338 6.77049 5.91195 6.4364 6.17418 6.17417C6.4364 5.91195 6.77049 5.73337 7.13421 5.66103C7.49792 5.58868 7.87492 5.62581 8.21753 5.76773C8.56014 5.90964 8.85298 6.14996 9.05901 6.45831C9.26503 6.76665 9.375 7.12916 9.375 7.5C9.375 7.99728 9.17746 8.4742 8.82583 8.82583C8.4742 9.17746 7.99728 9.375 7.5 9.375Z"
                        :fill="passedButtonIconColor" />
                    </svg>

                    Certificate
                  </base-button>
                  <base-button type="primary" outline="true" class="mr-0 mb-3 mb-md-0  px-2 passed-btn"
                    v-else-if="certificate.manual == 1" @click="previewManualCertificate(certificate.certificate_url)">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.888 6.98812C14.3393 5.78812 12.1874 1.875 7.49992 1.875C2.81242 1.875 0.660545 5.78812 0.111795 6.98812C0.0381309 7.14894 0 7.32374 0 7.50063C0 7.67751 0.0381309 7.85231 0.111795 8.01313C0.660545 9.21188 2.81242 13.125 7.49992 13.125C12.1874 13.125 14.3393 9.21188 14.888 8.01188C14.9616 7.85124 14.9996 7.67666 14.9996 7.5C14.9996 7.32334 14.9616 7.14876 14.888 6.98812ZM7.49992 11.875C3.55804 11.875 1.71867 8.52125 1.24992 7.50687C1.71867 6.47875 3.55804 3.125 7.49992 3.125C11.4324 3.125 13.2724 6.46438 13.7499 7.5C13.2724 8.53562 11.4324 11.875 7.49992 11.875Z"
                        :fill="passedButtonIconColor" />
                      <path
                        d="M7.5 4.375C6.88193 4.375 6.27775 4.55828 5.76384 4.90166C5.24994 5.24504 4.8494 5.7331 4.61288 6.30411C4.37635 6.87513 4.31447 7.50347 4.43505 8.10966C4.55563 8.71585 4.85325 9.27267 5.29029 9.70971C5.72733 10.1467 6.28415 10.4444 6.89034 10.565C7.49653 10.6855 8.12487 10.6236 8.69589 10.3871C9.26691 10.1506 9.75496 9.75006 10.0983 9.23616C10.4417 8.72225 10.625 8.11807 10.625 7.5C10.624 6.6715 10.2944 5.87722 9.70861 5.29139C9.12278 4.70555 8.3285 4.37599 7.5 4.375ZM7.5 9.375C7.12916 9.375 6.76665 9.26503 6.45831 9.05901C6.14996 8.85298 5.90964 8.56014 5.76773 8.21753C5.62581 7.87492 5.58868 7.49792 5.66103 7.13421C5.73338 6.77049 5.91195 6.4364 6.17418 6.17417C6.4364 5.91195 6.77049 5.73337 7.13421 5.66103C7.49792 5.58868 7.87492 5.62581 8.21753 5.76773C8.56014 5.90964 8.85298 6.14996 9.05901 6.45831C9.26503 6.76665 9.375 7.12916 9.375 7.5C9.375 7.99728 9.17746 8.4742 8.82583 8.82583C8.4742 9.17746 7.99728 9.375 7.5 9.375Z"
                        :fill="passedButtonIconColor" />
                    </svg>

                    Certificate
                  </base-button>
                  <base-button type="primary" outline="true" class="mr-0 mb-3 mb-md-0  px-2 passed-btn"
                    v-else-if="certificate.is_proctored_exam == 1" @click.prevent="
                      getProctoredExamCertificate(certificate.certificate_url)
                      ">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.888 6.98812C14.3393 5.78812 12.1874 1.875 7.49992 1.875C2.81242 1.875 0.660545 5.78812 0.111795 6.98812C0.0381309 7.14894 0 7.32374 0 7.50063C0 7.67751 0.0381309 7.85231 0.111795 8.01313C0.660545 9.21188 2.81242 13.125 7.49992 13.125C12.1874 13.125 14.3393 9.21188 14.888 8.01188C14.9616 7.85124 14.9996 7.67666 14.9996 7.5C14.9996 7.32334 14.9616 7.14876 14.888 6.98812ZM7.49992 11.875C3.55804 11.875 1.71867 8.52125 1.24992 7.50687C1.71867 6.47875 3.55804 3.125 7.49992 3.125C11.4324 3.125 13.2724 6.46438 13.7499 7.5C13.2724 8.53562 11.4324 11.875 7.49992 11.875Z"
                        :fill="passedButtonIconColor" />
                      <path
                        d="M7.5 4.375C6.88193 4.375 6.27775 4.55828 5.76384 4.90166C5.24994 5.24504 4.8494 5.7331 4.61288 6.30411C4.37635 6.87513 4.31447 7.50347 4.43505 8.10966C4.55563 8.71585 4.85325 9.27267 5.29029 9.70971C5.72733 10.1467 6.28415 10.4444 6.89034 10.565C7.49653 10.6855 8.12487 10.6236 8.69589 10.3871C9.26691 10.1506 9.75496 9.75006 10.0983 9.23616C10.4417 8.72225 10.625 8.11807 10.625 7.5C10.624 6.6715 10.2944 5.87722 9.70861 5.29139C9.12278 4.70555 8.3285 4.37599 7.5 4.375ZM7.5 9.375C7.12916 9.375 6.76665 9.26503 6.45831 9.05901C6.14996 8.85298 5.90964 8.56014 5.76773 8.21753C5.62581 7.87492 5.58868 7.49792 5.66103 7.13421C5.73338 6.77049 5.91195 6.4364 6.17418 6.17417C6.4364 5.91195 6.77049 5.73337 7.13421 5.66103C7.49792 5.58868 7.87492 5.62581 8.21753 5.76773C8.56014 5.90964 8.85298 6.14996 9.05901 6.45831C9.26503 6.76665 9.375 7.12916 9.375 7.5C9.375 7.99728 9.17746 8.4742 8.82583 8.82583C8.4742 9.17746 7.99728 9.375 7.5 9.375Z"
                        :fill="passedButtonIconColor" />
                    </svg>

                    Certificate
                  </base-button>

                  <base-button type="primary" outline="true" class="px-2 py-2 passed-btn" name="Take Course"
                    v-if="certificate.manual == 0 && certificate.is_proctored_exam == 0" @click="
                      generateDownloadCertificate(
                        course.id,
                        user_id,
                        course.certificate_id,
                        certificate.is_coursefolder
                      )
                      ">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.99984 8.6665L2.6665 5.33317L3.59984 4.3665L5.33317 6.09984V0.666504H6.6665V6.09984L8.39984 4.3665L9.33317 5.33317L5.99984 8.6665ZM1.99984 11.3332C1.63317 11.3332 1.31939 11.2027 1.0585 10.9418C0.797615 10.6809 0.666948 10.3669 0.666504 9.99984V7.99984H1.99984V9.99984H9.99984V7.99984H11.3332V9.99984C11.3332 10.3665 11.2027 10.6805 10.9418 10.9418C10.6809 11.2032 10.3669 11.3336 9.99984 11.3332H1.99984Z"
                        :fill="passedButtonIconColor" />
                    </svg>

                    Downlaod
                  </base-button>
                  <base-button type="primary" outline="true" class="px-2 py-2 passed-btn" name="Take Course"
                    v-else-if="certificate.manual == 1" @click="downloadManualCertificate(certificate.certificate_url)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.99984 8.6665L2.6665 5.33317L3.59984 4.3665L5.33317 6.09984V0.666504H6.6665V6.09984L8.39984 4.3665L9.33317 5.33317L5.99984 8.6665ZM1.99984 11.3332C1.63317 11.3332 1.31939 11.2027 1.0585 10.9418C0.797615 10.6809 0.666948 10.3669 0.666504 9.99984V7.99984H1.99984V9.99984H9.99984V7.99984H11.3332V9.99984C11.3332 10.3665 11.2027 10.6805 10.9418 10.9418C10.6809 11.2032 10.3669 11.3336 9.99984 11.3332H1.99984Z"
                        :fill="passedButtonIconColor" />
                    </svg>

                    Downlaod
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <span v-if="is_passed">
          <div class="grid-wrap border rounded p-3">
            <img :src="emptySlotIcon" alt="No data available" class="w-100"
              style="max-width: 300px; margin: 0 auto; display: block" />
          </div>
        </span>
      </span>
    </card>
   
    <modal :show.sync="show2faModal">
      <h3 slot="header" class="title title-up text-primary text-center">
        <u>Two-Factor Authentication Required to Continue</u>
      </h3>
      <form>
        <div class="row">
          <div class="col-md-12">
            <h5>
              This course requires a Two-Factor Authentication to verify your identity. We
              will send you a verification code to your registered phone number. If you do
              not have a number on file, please enter it below.
            </h5>
          </div>
          <div class="col-md-12">
            <label><b>Registered Phone Number:</b></label>
          </div>

          <div class="col-md-7">
            <base-input type="tel" placeholder="Enter new phone number" v-model="newphonenumber"
              @input="acceptNumber"></base-input>
          </div>
          <div class="col-md-5" style="padding: 0px !important" v-if="changePhoneNum">
            <label> (<a class="linkColor" @click.prevent="cancelPhone">Cancel</a>)</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>Select verification channel:</label>
          </div>
          <div class="col-md-3">
            <input type="radio" name="verificationtype" value="sms" v-model="verificationType" />
            Text
          </div>
          <div class="col-md-3">
            <input type="radio" name="verificationtype" value="call" v-model="verificationType" />
            Call
          </div>
          <div class="col-md-12 mt-4">
            <base-button name="Send Verification" type="success" @click.prevent="sendVerification" size="sm">Start
              Verification</base-button>
          </div>
        </div>
      </form>
    </modal>
    <modal :show.sync="askOtpModal">
      <h3 slot="header" class="title title-up text-primary text-center">Enter Code</h3>
      <form>
        <div class="row">
          <div class="col-md-6">
            <base-input type="number" v-model="otp" placeholder="Enter Code"></base-input>
          </div>
          <div class="col-md-6">
            <base-button name="Verify OTP" type="success" @click.prevent="verifyOtp" size="sm">Verify</base-button>
          </div>
        </div>
      </form>
    </modal>
    <modal :show.sync="payCourseModel">
      <h4 slot="header" style="color: #444c57" class="modal-title mb-0">Payment</h4>

      <pay-by-employee v-if="payCourseModel" type="payByEmployee" :amountPayable="discountedCost"
        :orignalAmount="orignalCost" :discount="is_payByEmployeeDiscount" :address="this.address" :city="this.city"
        :state="this.state" :zipcode="this.zipcode" v-on:payClicked="payClicked" />
    </modal>

    <modal :show.sync="safedigAddCourseModal" class="ignore-translation safedig-course-library-modal">
      <h3 slot="header" class="d-flex align-items-center m-0 safedig-modal-title">
        Course library
      </h3>
      <div class="safedig-course-picker">
        <p class="safedig-picker-lead">
          Search the library, select one or more courses, and add them to your account.
        </p>
        <div class="safedig-search-field">
          <label class="safedig-sr-only" for="safedig-course-search-input">Search courses</label>
          <div class="safedig-search-inner">
            <i class="fas fa-search safedig-search-icon" aria-hidden="true"></i>
            <input
              id="safedig-course-search-input"
              v-model="safedigSearchQuery"
              type="search"
              class="safedig-search-input"
              placeholder="Search by course name"
              autocomplete="off"
              enterkeyhint="search"
            />
          </div>
        </div>
        <div class="safedig-course-scroll safedig-course-grid-outer" @scroll="handleSafeDigScroll">
          <div class="safedig-course-grid">
            <article
              v-for="list in safedigListCourses"
              :key="'sd-' + list.id"
              class="safedig-course-card"
              :class="{ 'safedig-course-card--selected': isSafeDigCourseSelected(list) }"
              role="button"
              tabindex="0"
              :aria-pressed="isSafeDigCourseSelected(list)"
              :aria-label="(isSafeDigCourseSelected(list) ? 'Deselect ' : 'Select ') + list.name"
              @click="toggleSafeDigCourse(list)"
              @keydown.enter.prevent="toggleSafeDigCourse(list)"
              @keydown.space.prevent="toggleSafeDigCourse(list)"
            >
              <div class="safedig-course-card__row">
                <span class="safedig-course-card__icon" aria-hidden="true">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                </span>
                <h4 class="safedig-course-card__title">{{ list.name }}</h4>
                <span
                  class="safedig-course-card__mark"
                  :class="{ 'safedig-course-card__mark--on': isSafeDigCourseSelected(list) }"
                  aria-hidden="true"
                >
                  <svg
                    v-if="isSafeDigCourseSelected(list)"
                    class="safedig-course-card__mark-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="11" fill="currentColor" />
                    <path
                      d="M7.5 12.5l2.5 2.5 6-6"
                      stroke="#fff"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <svg
                    v-else
                    class="safedig-course-card__mark-svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="2" />
                  </svg>
                </span>
              </div>
            </article>
          </div>
          <div v-if="safedigLoadingList" class="safedig-loading-row">
            <div class="orange-loader"></div>
          </div>
          <div
            v-if="!safedigLoadingList && safedigListCourses.length === 0"
            class="safedig-empty-state"
            role="status"
          >
            <p class="safedig-empty-state__title">No courses found</p>
            <p class="safedig-empty-state__hint">Try a different search term.</p>
          </div>
        </div>
        <footer class="safedig-picker-footer">
          <div class="safedig-picker-footer__meta">
            <span v-if="safedigSelectedCourses.length" class="safedig-selection-pill">
              {{ safedigSelectedCourses.length }}
              {{ safedigSelectedCourses.length === 1 ? 'course' : 'courses' }} selected
            </span>
          </div>
          <div class="safedig-picker-footer__actions">
            <base-button type="secondary" outline class="mr-2" @click.prevent="safedigAddCourseModal = false">
              Cancel
            </base-button>
            <base-button
              type="primary"
              :disabled="!safedigSelectedCourses.length || safedigAssigning"
              @click.prevent="submitSafeDigAssignCourses"
            >
              {{ safedigAssigning ? 'Adding…' : 'Add to my account' }}
            </base-button>
          </div>
        </footer>
      </div>
    </modal>

    <modal :show.sync="purchaseNewCourseModal"  class="ignore-translation">
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showPurchaseTypeSelection">
        Purchase Options
      </h3>
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showCourseList">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg"
          @click="backToPurchaseTypeSelection" class="mr-3" v-if="hot_user == 'company-admin'" />
        Course
        Library
      </h3>
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showCourseDetails">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg" @click="showListView"
          class="mr-3" />
        Course Details
      </h3>
      <!-- <h3 slot="header" class="d-flex align-items-center m-0" v-if="showCheckoutModal && selectedEmployees.length==0"> -->
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showCheckoutModal">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg" @click="showListViewBack"
          class="mr-3" />
        Course Checkout
      </h3>
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showCheckoutModal && selectedEmployees.length > 0">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg" @click="showEmpScreen()"
          class="mr-3" />
        Course Checkout
      </h3>
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showPaymentWindow">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg" @click="backToCheckout()"
          class="mr-3" />
        Payment
      </h3>
      <h3 slot="header" class="d-flex align-items-center m-0" v-if="showEmpListModal">
        <img width="15px" style="cursor: pointer" src="/img/icons/common/back-arrow.svg" @click="backToCouse"
          class="mr-3" />
        Select Employees
      </h3>


      <!-- NEW: Purchase Type Selection Content -->
      <div v-show="showPurchaseTypeSelection" class="course-content-modal purchase-type-selection">
        <div class="purchase-type-container text-center">
          <div class="purchase-type-header mb-4">
            <h4 class="mb-3">Who are you purchasing courses for?</h4>
            <p class="text-muted">Choose your purchase option to continue</p>
          </div>

          <div class="purchase-type-buttons">
            <div class="row justify-content-center">
              <div class="col-md-5 mb-3" style="cursor: pointer;">
                <div class="purchase-type-card" @click="selectPurchaseType('self')">
                  <div class="card border rounded-lg p-4 h-100 purchase-card-hover" style="box-shadow:none;">
                    <div class="card-body text-center">
                      <div class="purchase-icon mb-3">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                            :fill="purchaseIconColor" />
                          <path d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z" :fill="purchaseIconColor" />
                        </svg>
                      </div>
                      <h5 class="card-title mb-2">Purchase for Myself</h5>
                      <p class="card-text text-muted small">Buy courses for your personal learning</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-5 mb-3" v-if="hot_user == 'company-admin'" style="cursor: pointer;">
                <div class="purchase-type-card" @click="selectPurchaseType('employees')">
                  <div class="card border rounded-lg p-4 h-100 purchase-card-hover" style="box-shadow:none;">
                    <div class="card-body text-center">
                      <div class="purchase-icon mb-3">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16 4C18.2091 4 20 5.79086 20 8C20 10.2091 18.2091 12 16 12C13.7909 12 12 10.2091 12 8C12 5.79086 13.7909 4 16 4Z"
                            :fill="purchaseIconColor" />
                          <path
                            d="M8 6C9.65685 6 11 4.65685 11 3C11 1.34315 9.65685 0 8 0C6.34315 0 5 1.34315 5 3C5 4.65685 6.34315 6 8 6Z"
                            :fill="purchaseIconColor" />
                          <path d="M8 8C5.79086 8 4 9.79086 4 12V16H12V12C12 9.79086 10.2091 8 8 8Z" :fill="purchaseIconColor" />
                          <path d="M16 14C13.7909 14 12 15.7909 12 18V22H20V18C20 15.7909 18.2091 14 16 14Z"
                            :fill="purchaseIconColor" />
                        </svg>
                      </div>
                      <h5 class="card-title mb-2">Purchase for Employees</h5>
                      <p class="card-text text-muted small">Buy courses for your team members</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="course-content-modal course-selection" v-show="showCourseList">
        <!-- <el-select v-model="value1" multiple placeholder="Select" class="w-100">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <base-input label="Select Course(s)" v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search">
        </base-input>



        <div class="course-selection-home border rounded-lg shadow p-3 mb-2" style="max-height: 330px; overflow-y: auto"
          @scroll="handleScroll">
          <div v-for="list in FilterlistCourses" :key="list.id"
            class="course-block d-flex justify-content-between align-items-center border-bottom pb-3 mb-3 hover-highlight"
            :class="{ 'selected-course': isCourseSelected(list) }" @click="toogleCourse(list)">
            <div class="d-flex align-items-center">
              <img width="80" height="80" class="m-2"
                :src="list.image_url ? list.image_url : `https://placehold.co/80x80`" loading="lazy" alt="" />
              <div class="">
                <h3 class="mb-2">
                  {{ list.name }}
                <!-- old -->
                <span v-if="list.is_discounted_course !== 1 && selectedSpecialCourseIDsAndUsers[list.id]">
                  ({{ selectedSpecialCourseIDsAndUsers[list.id] }} user<span v-if="selectedSpecialCourseIDsAndUsers[list.id] > 1">s</span>)
                </span>



                </h3>
                <span class="link-withsvg" @click.stop="showCourseDetailsView(list, true)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.8807 7.454C15.2954 6.174 13 2 8.00004 2C3.00004 2 0.704703 6.174 0.11937 7.454C0.0407951 7.62553 0.00012207 7.81199 0.00012207 8.00067C0.00012207 8.18934 0.0407951 8.3758 0.11937 8.54733C0.704703 9.826 3.00004 14 8.00004 14C13 14 15.2954 9.826 15.8807 8.546C15.9591 8.37466 15.9997 8.18843 15.9997 8C15.9997 7.81157 15.9591 7.62534 15.8807 7.454ZM8.00004 12.6667C3.79537 12.6667 1.83337 9.08933 1.33337 8.00733C1.83337 6.91067 3.79537 3.33333 8.00004 3.33333C12.1947 3.33333 14.1574 6.89533 14.6667 8C14.1574 9.10467 12.1947 12.6667 8.00004 12.6667Z"
                      fill="#525252" />
                    <path
                      d="M8.00008 4.66699C7.34081 4.66699 6.69635 4.86249 6.14818 5.22876C5.60002 5.59503 5.17278 6.11563 4.92048 6.72471C4.66819 7.3338 4.60218 8.00402 4.7308 8.65063C4.85942 9.29723 5.17689 9.89117 5.64306 10.3573C6.10924 10.8235 6.70318 11.141 7.34978 11.2696C7.99639 11.3982 8.66661 11.3322 9.27569 11.0799C9.88478 10.8276 10.4054 10.4004 10.7716 9.85223C11.1379 9.30406 11.3334 8.6596 11.3334 8.00033C11.3324 7.1166 10.9808 6.26936 10.3559 5.64447C9.73104 5.01958 8.88381 4.66805 8.00008 4.66699ZM8.00008 10.0003C7.60452 10.0003 7.21784 9.88303 6.88894 9.66326C6.56004 9.4435 6.3037 9.13114 6.15232 8.76569C6.00095 8.40024 5.96134 7.99811 6.03851 7.61015C6.11568 7.22218 6.30616 6.86582 6.58587 6.58611C6.86557 6.30641 7.22194 6.11593 7.6099 6.03875C7.99786 5.96158 8.4 6.00119 8.76545 6.15257C9.1309 6.30394 9.44326 6.56029 9.66302 6.88918C9.88278 7.21808 10.0001 7.60476 10.0001 8.00033C10.0001 8.53076 9.78937 9.03947 9.4143 9.41454C9.03922 9.78961 8.53052 10.0003 8.00008 10.0003Z"
                      fill="#525252" />
                  </svg>
                  View Detail
                </span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-end m-2">
              <span>
                <input type="checkbox" :id="'list-course' + list.id" :checked="isCourseSelected(list)"
                  @click.stop="toogleCourse(list)" class="mb-2" />
              </span>
              <b>${{ twoDecimalFunction(list.cost) }}</b>
            </div>
          </div>

          <div v-if="isLoading" class="loading-indicator">
            <div class="spinner-border text-primary text-center" role="status">

              <div class="orange-loader"></div>
            </div>
          </div>

          <!-- End of content message -->
          <!-- <div v-if="!hasMoreCourses" class="text-center py-2 text-muted small">
                No more courses to load
              </div> -->
        </div>

        <div class="text-center mt-5">
          <base-button v-if="type == 'self'" type="primary" size="lg" class="w-100 mb-3"
            @click.prevent="purchaseClick(1)">
            <!-- Purchase For Myself -->
            Next
          </base-button>
          <base-button v-if="hot_user == 'company-admin' && type == 'other'" type="primary" outline="true" size="lg"
            class="w-100" @click.prevent="purchaseClick(0)">
            Next
          </base-button>
        </div>
        <div class="clearfix"></div>
      </div>

      <div v-show="showCourseDetails" class="course-content-modal course-detail">
        <img width="100%" style="max-height: 250px" class="mb-3" :src="showSingleCourse.image_url
          ? showSingleCourse.image_url
          : `https://vumbnail.com/${showSingleCourse.video}.jpg`" alt="image" loading="lazy" />
        <h2 class="d-flex justify-content-between align-items-center">
          <span class="head mr-5">{{ showSingleCourse.name }} </span>
          <span class="price">${{ showSingleCourse.cost }}</span>
        </h2>
        <div class="review-area-wrap d-flex align-items-center mb-3">
          <div class="stars mr-3">
            <img width="18" class="mr-1" src="/img/icons/common/star.svg" alt="" />
            <img width="18" class="mr-1" src="/img/icons/common/star.svg" alt="" />
            <img width="18" class="mr-1" src="/img/icons/common/star.svg" alt="" />
            <img width="18" class="mr-1" src="/img/icons/common/star.svg" alt="" />
            <img width="18" class="mr-1" src="/img/icons/common/star.svg" alt="" />
          </div>
          <span class="review-content"><b>4.0 (4.2k reviews)</b></span>
        </div>
        <p v-html="showSingleCourse.description"></p>
        <!-- <div class="text-center mt-5">
          <base-button type="primary" size="lg" class="w-100 mb-2"> Buy Now </base-button>
        </div> -->
      </div>

      <div v-show="showEmpListModal" class="course-content-modal select-employe position-relative">
        <base-input v-model="searchEmp" prepend-icon="fas fa-search" placeholder="Search">
        </base-input>
        <div class="role-filter-drop-down position-absolute">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <img src="img/icons/common/filter-icon.svg">
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="filter in userfilters" :key="filter.value"
                @click.native="applyFilter(filter.value)">
                {{ filter.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="search-dropdown" style="max-height: 300px; overflow-y: auto">
          <ul class="border p-0 m-0 rounded-lg">

            <!-- Select All / Deselect All Checkbox -->
            <li class="d-flex justify-content-between p-3 border-bottom">
              <span><strong>{{ selectedFilter }}</strong></span>
              <span>
                <input type="checkbox" id="select-all" v-model="selectAll" @change="toggleAllEmployees" class="m-0" />
              </span>
            </li>

            <li v-for="(emp, index) in FilterlistEmployee" :key="emp.id"
              class="d-flex justify-content-between p-3 border-bottom">
              <span>{{ emp.full_name }} </span>
              <span>
                <input type="checkbox" :id="'list-course' + index" v-model="selectedEmployees" :value="emp"
                  class="m-0" />
              </span>
            </li>
          </ul>
        </div>

        <div class="text-center mt-5">
          <base-button type="primary" size="lg" class="w-100 mb-2" @click.prevent="showCheckoutModalEmps">
            Next
          </base-button>
        </div>
      </div>

      <div v-show="showCheckoutModal"  class="course-content-modal buy-course-modal-wrap">
        <div class="checkout-scrollable" style="max-height:30vh; overflow-y:auto;">
          <div v-for="course in selectedCourses" :key="course.id"
            class="course-block d-flex justify-content-between align-items-center border rounded-lg shadow p-3 mb-2">
            <div class="d-flex align-items-center">
              <img width="80" height="80" class="mr-3" loading="lazy"
                :src="course.image_url ? course.image_url : `https://vumbnail.com/${course.video}.jpg`" alt="" />
              <div class="">
                <h3 class="mb-2 course-title-hover" @click.stop="showCourseDetailsView1(course, true)">
                  {{ course.name }}
                  <!-- Show user count for special courses or "unlimited" for regular courses -->
                  <!-- <span v-if="course.is_discounted_course !== 1 && selectedSpecialCourseIDsAndUsers[course.id]">
                    ({{ selectedSpecialCourseIDsAndUsers[course.id] }} user<span v-if="selectedSpecialCourseIDsAndUsers[course.id] > 1">s</span>)
                  </span>
                  <span v-else-if="course.is_discounted_course === 1">
                    (unlimited)
                  </span> -->
                </h3>
                <!-- NEW: Conditional display based on course type -->
                <!-- For Special Courses: Show Quantity Selector -->
                <span v-if="type == 'other'">
                  <div v-if="course.is_discounted_course !== 1" class="quantity-selector-container">
                    <div class="quantity-selector d-flex align-items-center">
                      <button class="quantity-btn minus-btn" @click="decreaseQuantity(course.id)"
                        :disabled="getQuantity(course.id) <= 1">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 1H12" stroke="currentColor" stroke-width="2" />
                        </svg>
                      </button>

                      <input type="number" class="quantity-input" :value="getQuantity(course.id)"
                        @input="updateQuantity(course.id, $event.target.value)"
                        @blur="validateAndUpdateQuantity(course.id, $event.target.value)" min="1" max="9999" />

                      <button class="quantity-btn plus-btn" @click="increaseQuantity(course.id)">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 0V12M0 6H12" stroke="currentColor" stroke-width="2" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- For Regular Courses: Show "unlimited" text -->
                  <div v-else class="unlimited-text">
                    <span class="text-muted">
                      <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M2 8C2 8 3.5 5 8 5S14 8 14 8S12.5 11 8 11S2 8 2 8Z" stroke="#6c757d" stroke-width="1.5"/>
                         <circle cx="8" cy="8" r="2" stroke="#6c757d" stroke-width="1.5"/>
                       </svg> -->
                      Unlimited users
                    </span>
                  </div>
                </span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-end">
              <b class="mb-2">${{ twoDecimalFunction(course.cost) }}</b>
              <a style="cursor: pointer;" class="remove-anchor" @click.prevent="toogleCourse(course)">
                Remove <span>x</span>
              </a>
            </div>
          </div>

        </div>

        <div class="payment-summary-block mt-4">
          <div class="discount-code-area pt-3 custom-border-color" v-if="!promoCodeApplied">
            <div class="d-flex align-items-center gap-2 mb-3">
              <input class="form-control rounded-4 py-2 mr-2" v-model="promo_code" type="text"
                placeholder="Enter promo code" style="max-width: 250px;" />
              <button class="btn btn-primary rounded-4 px-4 py-2 text-white" @click.prevent="applyPromoCode">
                Apply
              </button>
            </div>
          </div>

          <div class="d-flex justify-content-between mb-2" v-else>
            <span class="promocode-applied m-0">Promotional Discount Applied ({{
              discount_percentage
            }}%)
            </span>
            <span style="cursor: pointer;" @click.prevent="removePromoCode">
              <i class="fas fa-times"></i> </span>
          </div>
          <!-- Pricing Type Selection -->
          <div class="mb-4 d-flex align-items-center gap-3">
            <label class="d-flex align-items-center mr-4" v-if="type == 'other'">
              <input type="radio" value="monthly" v-model="pricingType" @change="onPlanTypeChange" />
              <span class="ml-2">Monthly</span>
            </label>

            <label class="d-flex align-items-center" v-if="type == 'other'">
              <input type="radio" value="yearly" v-model="pricingType" @change="onPlanTypeChange" />
              <span class="ml-2">Yearly</span>
            </label>
          </div>
         
<table style="width: 100%; table-layout: fixed; border-collapse: separate; border-spacing: 0 5px;" class="summary-block-inner-font">
  <thead style="background-color: #f5f5f5;">
    <tr style="text-align: center;">
      <th style="padding: 10px; text-align: left;" v-show="forEmps">Course Name</th>
      <th style="padding: 10px;" v-show="forEmps">Qty</th>
      <th style="padding: 10px;" v-show="forEmps">Rate</th>
      <th style="padding: 10px; text-align: right;" v-show="forEmps">Total</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(values, index) in specialCourseSummary" :key="'special-' + index">
      <td style="word-wrap: break-word; padding: 10px;">{{ values.name }}</td>
      <td style="text-align: center; padding: 10px;">{{ values.quantity }}</td>
      <td style="text-align: center; padding: 10px;">${{ twoDecimalFunction(values.price) }}</td>
      <td style="text-align: right; padding: 10px;">
        <span v-if="isMonthly">${{ twoDecimalFunction(values.monthly_price) }}</span>
        <span v-else>${{ twoDecimalFunction(values.yearly_price) }}</span>
      </td>
    </tr>

    <tr v-for="(values, index) in baseCourseSummary" :key="'base-' + index">
      <td style="word-wrap: break-word; padding: 10px;">{{ values.name }}</td>
      <td style="text-align: center; padding: 10px;">{{ values.quantity }}</td>
      <td style="text-align: center; padding: 10px;">${{ twoDecimalFunction(values.price) }}</td>
      <td style="text-align: right; padding: 10px;">
        <span v-if="isMonthly">${{ twoDecimalFunction(values.monthly_price) }}</span>
        <span v-else>${{ twoDecimalFunction(values.yearly_price) }}</span>
      </td>
    </tr>
  </tbody>
</table>



          <span>

            <div class="d-flex justify-content-between mb-2 summary-block-inner-font" v-if="isMonthly">
              <span>Total Amount
                 <template v-if="forEmps">(Monthly)</template>
              </span>
              <strong>${{ twoDecimalFunction(perMonthCost) }}</strong>

            </div>

            <!-- Yearly Summary (show only if selected) -->
            <div class="d-flex justify-content-between mb-2 summary-block-inner-font" v-if="isYearly">
              <!-- <span>Total Amount Yearly(10% off)</span> -->
              <span>Total Amount
                 <template v-if="forEmps">(Yearly)</template>
              </span>

              <strong>${{ twoDecimalFunction(perYearCost) }} </strong>
            </div>
          </span>

          <!-- </span> -->

        </div>

        <div class="text-center mt-5">

          <!-- ✅ Show when courses are selected -->
          <!-- <base-button
          v-if="selectedCourses.length > 0"
          type="primary"
          size="lg"
          @click.prevent="PayCourse(selectedCourses, 'purchase')"
          class="w-100 mb-2"
        >
          Next6
        </base-button>  -->

          <div v-if="selectedCourses.length > 0" class="d-flex  justify-content-between gap-3 flex-wrap">

            <!-- Back Button -->
            <base-button type="primary" size="lg" outline="true" @click="showListViewBack"
              class="custom-button-width mr-2">
              Back
            </base-button>

            <!-- Next Button -->
            <base-button type="primary" size="lg" @click.prevent="PayCourse(selectedCourses, 'purchase')"
              class="custom-button-width mr-2">
              Next
            </base-button>
          </div>


          <!-- ❌ Show message when no courses are selected -->
          <div v-else class="alert alert-danger w-100 py-3">
            Please select at least one course
          </div>
        </div>
      </div>

      <div v-show="showPaymentWindow" class="course-content-modal payment-modal">
        <div class="row">
          <div class="col-md-12">
            <pay-by-employee type="payByEmployee" :amountPayable="isMonthly ? perMonthCost : perYearCost"
              :orignalAmount="orignalCost" :discount="is_payByEmployeeDiscount" :address="address" :city="city"
              :state="state" :zipcode="zipcode" v-on:payClicked="paymentClicked" />
          </div>
        </div>

      </div>

      <div class="course-content-modal buy-course-modal-wrap d-none">
        <div class="thank-header d-flex justify-content-center align-items-center flex-column">
          <img class="mb-2" width="150" src="/img/icons/common/thankyou.svg" alt="" />
          <h2 class="mb-0">Congratulations</h2>
          <p class="mb-4">You've Purchased Course Successfully</p>
        </div>
        <div class="course-purchase-detail rounded-lg py-3">
          <ul class="p-0 m-0">
            <li class="d-flex justify-content-between px-3 pb-3 mb-3">
              <span>Name</span>
              <strong>Adriana Corado</strong>
            </li>
            <li class="d-flex justify-content-between px-3 pb-3 mb-3">
              <span>Date</span>
              <strong>20 july 2025</strong>
            </li>
            <li class="d-flex justify-content-between px-3 pb-3 mb-3">
              <span>Course Name</span>
              <strong>Food Handler Training</strong>
            </li>
            <li class="d-flex justify-content-between px-3">
              <span>Total Amount</span>
              <strong>$50.00</strong>
            </li>
          </ul>
        </div>

        <div class="text-center mt-5">
          <base-button type="primary" size="lg" class="w-100 mb-2">
            Back To Home
          </base-button>
        </div>
      </div>
    </modal>
    <modal :show.sync="showusermodel">
      <h4 slot="header" style="color: #444c57" class="title title-up text-center">
        {{ specialCourseName }}

      </h4>

      <div class="col-md-8">
        <base-input label="How many users will be taking this course:" type="text" name="# Users"
          v-model="usersofSpecialCourse"></base-input>
      </div>
      <div class="col-md-6">
        <base-button size="md" class="custom-btn right"
          style="background-color: #e66412; color: white; border-color: #e66412"
          @click.prevent="confirmSpecialCourseUsers()">Done</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Checkbox, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import PayByEmployee from "./PayByEmployee.vue";
import PayPurchaseCourse from "./PayPurchaseCourse.vue";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import Swal from "sweetalert2";
import moment from "moment";
import FolderProgressGraph from "@/views/Super/FolderProgressGraph.vue";
import Allcourses from "./EmployeeCourses/AllCourses.vue";
import { StripeElementCard } from '@vue-stripe/vue-stripe';

// import OpenCourses from "./EmployeeCourses/OpenCourses.vue";

export default {
  mixins: [clientPaginationMixin],
  components: {
    forEmps: false,
    PayByEmployee,
    PayPurchaseCourse,
    Allcourses,
    StripeElementCard,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [Checkbox.name]: Checkbox,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,

    FolderProgressGraph,
  },
  data() {
    return {
      quantityUpdateTimer: null,
      showPurchaseTypeSelection: true,
      type: "",
      promo_code: "",
      discount_percentage: 0,
      promoCodeApplied: false,
      pricingType: 'monthly', // default selected
      isMonthly: true,
      isYearly: false,
      perYearCost: 0,
      perMonthCost: 0,
      courseToAssignUsers: null, // Add this if not present
      selectedCourses: [],
      selectedSpecialCourseIDsAndUsers: {}, // key: courseId, value: user count      showusermodel : false,
      usersofSpecialCourse: 0,
      specialCourseName: "",
      isPurchaseCourseVisible: true,
      newPayModal: false,
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      postalCode: true,
      loading: false,
      baseUrl: this.$baseUrl,
      height: 500,
      options: {},
      playerReady: false,
      fullPage: true,
      hot_user: "",
      hot_token: "",
      purchaseNewCourseModal: false,
      checked: true,
      // courseDetailModal: false,
      // buyCoursesModal: false,
      user_id: "",
      config: "",
      passed: "",
      opened: "",
      failed: "",
      expired: "",
      company_id: "",
      searchQuery: "",       // bound to input
      searchDebounce: null,  // for debounce
      searchEmp: "",
      tableData: [],
      selectedRows: [],
      videos: [],
      employeeStatus: "",
      show2faModal: false,
      is_authenticated: 0,
      phonenumber: "",
      newphonenumber: "",
      verificationType: "sms",
      changePhoneNum: false,
      askOtpModal: false,
      is_payByEmployeeOn: 0,
      payCourseModel: false,
      is_payByEmployeeDiscount: 0,
      otp: "",
      discountedCost: 0,
      orignalCost: 0,
      address: "",
      city: "",
      state: "",
      zipcode: "",
      addressAvailble: true,
      folderProgress: "",
      openCourses: 0,
      expiredCourses: 0,
      failedCourses: 0,
      passedCourses: 0,
      is_open_show: true,
      is_expired: false,
      is_failed: false,
      is_passed: false,
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      value1: [],
      listCourses: [],
      selectedCourses: [],
      showSingleCourse: "",
      showCourseList: false,
      showCourseDetails: false,
      showCheckoutModal: false,
      empTotalCost: 0,
      showPaymentWindow: false,
      empList: [],
      empListCopy: [],
      selectedEmployees: [],
      showEmpListModal: false,
      card: {
        cardNumber: "",
        expire: "",
        token: null,
      },
      formDataVal: {
        payment: {},
        selectedCourses: [],
        user_id: ""
      },
      selectAll: false,
      userfilters: [
        {
          value: "all",
          label: "Select All",
        },
        {
          value: "manager",
          label: "All Manager",
        },
        {
          value: "employee",
          label: "All Employee",
        },
        {
          value: "admin",
          label: "All Admin",
        },
      ],
      all: true,
      manager: false,
      emp: false,
      admin: false,
      selectedRole: "all",
      page: 1,
      lastPage: null,
      isLoading: false,
      fromhome: false,
      employeeCount: 0,
      baseCourseSummary:[],
      specialCourseSummary:[],
       openedFromCheckout: false,
      safedigAddCourseModal: false,
      safedigSearchQuery: '',
      safedigSearchDebounce: null,
      safedigListCourses: [],
      safedigPage: 1,
      safedigLastPage: null,
      safedigLoadingList: false,
      safedigSelectedCourses: [],
      safedigAssigning: false,
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    },
    passedButtonIconColor() {
      return this.isSafeDig ? '#3e7799' : '#FE672C';
    },
    purchaseIconColor() {
      return this.isSafeDig ? '#3e7799' : '#FE672C';
    },
    playIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/play_btn.svg')
        : '/play_btn.svg';
    },
    emptySlotIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/safedig_empty_slot.svg')
        : 'img/theme/empty_slot.png';
    },
    courseStatusIcons() {
      if (this.isSafeDig) {
        return {
          open: require('@/assets/safe-dig/svg-icons/opened_courses.svg'),
          passed: require('@/assets/safe-dig/svg-icons/passesd_courses.svg'),
          failed: require('@/assets/safe-dig/svg-icons/failed_courses.svg'),
          expired: require('@/assets/safe-dig/svg-icons/expired_courses.svg')
        };
      }
      return {
        open: 'img/svg-icons/opened_courses.svg',
        passed: 'img/svg-icons/passesd_courses.svg',
        failed: 'img/svg-icons/failed_courses.svg',
        expired: 'img/svg-icons/expired_courses.svg'
      };
    },
    // Filters courses based on search query
    FilterlistCourses() {
      let filteredCourses = this.listCourses;

      // Apply search filter first
      if (this.searchQuery) {
        filteredCourses = filteredCourses.filter((course) =>
          course.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }

      // Sort courses: selected courses first, then unselected courses
      return filteredCourses.sort((a, b) => {
        const aSelected = this.isCourseSelected(a);
        const bSelected = this.isCourseSelected(b);

        // If both are selected or both are unselected, maintain original order
        if (aSelected === bSelected) {
          return 0;
        }

        // Selected courses come first (return -1 means 'a' comes before 'b')
        return aSelected ? -1 : 1;
      });
    },
    // Filters courses based on search query
    FilterlistEmployee() {
      let filteredList = this.empListCopy;

      // Apply role filter
      if (this.selectedRole !== "all") {
        const roleMap = {
          admin: 2,
          manager: 3,
          employee: 4,
        };
        filteredList = filteredList.filter(emp => emp.role_id === roleMap[this.selectedRole]);
      }

      // Apply search filter
      if (this.searchEmp) {
        filteredList = filteredList.filter(emp =>
          emp.full_name.toLowerCase().includes(this.searchEmp.toLowerCase())
        );
      }

      return filteredList;
    },
    selectedFilter() {
      const roleTitles = {
        admin: "Admins",
        manager: "Managers",
        employee: "Employees",
        all: "Users",
      };

      const roleKey = this.selectedRole || "all";
      return `Select All ${roleTitles[roleKey]}`;
    },
  },
  mounted() {
    //   this.$nextTick(() => {
    //   console.log("Stripe component loaded:", this.$refs.elementRef);
    // });
  },

  created() {
    // console.log("Stripe Public Key:", this.publicKey);
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");

      this.hot_token = localStorage.getItem("hot-token");
      this.company_id = localStorage.getItem("hot-company-id");
      if (this.hot_user === "company-admin") {
        this.user_id = localStorage.getItem("hot-admin-id");
        this.company_id = localStorage.getItem("hot-user-id");
      } else {
        this.user_id = localStorage.getItem("hot-user-id");
      }
    }
    if (this.$route.query.course) {
      if (this.$route.query.course === "open") {
        this.is_open_show = true;
      } else if (this.$route.query.course === "passed") {
        this.is_passed = true;
        this.is_open_show = false;
      } else if (this.$route.query.course === "failed") {
        this.is_failed = true;
        this.is_open_show = false;
      } else if (this.$route.query.course === "expired") {
        this.is_expired = true;
        this.is_open_show = false;
      }
      // this.employeeStatus = this.$route.query.course;
    }
    this.fetchData();
    this.folderProgressData();
    // this.listOfCourses();
    // this.listOfEmployees();
  },
  methods: {
    resetSafeDigAddCourseState() {
      this.safedigSearchQuery = '';
      this.safedigListCourses = [];
      this.safedigPage = 1;
      this.safedigLastPage = null;
      this.safedigSelectedCourses = [];
      this.safedigAssigning = false;
      this.safedigLoadingList = false;
    },
    openSafeDigAddCourseModal() {
      this.resetSafeDigAddCourseState();
      this.safedigAddCourseModal = true;
      this.$nextTick(() => {
        this.listOfCoursesSafeDig(true);
      });
    },
    handleSafeDigScroll(event) {
      const el = event.target;
      const bottomReached =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      if (bottomReached) {
        this.listOfCoursesSafeDig(false);
      }
    },
    listOfCoursesSafeDig(reset = false) {
      if (this.safedigLoadingList) return;
      if (!reset && this.safedigLastPage && this.safedigPage > this.safedigLastPage) {
        return;
      }
      this.safedigLoadingList = true;
      const page = reset ? 1 : this.safedigPage;
      const requestData = {
        page,
        limit: 10,
        search: (this.safedigSearchQuery || '').trim(),
        company_id: this.company_id,
        user_role: this.hot_user,
        for_emps: false,
      };
      this.$http
        .post('list/purchase-courses', requestData)
        .then((response) => {
          const res = response.data;
          if (reset) {
            this.safedigListCourses = res.data || [];
            this.safedigPage = 2;
          } else {
            const next = res.data || [];
            const existingIds = new Set(this.safedigListCourses.map((c) => c.id));
            next.forEach((c) => {
              if (!existingIds.has(c.id)) {
                this.safedigListCourses.push(c);
                existingIds.add(c.id);
              }
            });
            this.safedigPage += 1;
          }
          this.safedigLastPage = res.last_page;
        })
        .catch(() => {
          Swal.fire({
            title: 'Error',
            text: 'Unable to load courses. Please try again.',
            icon: 'error',
          });
        })
        .finally(() => {
          this.safedigLoadingList = false;
        });
    },
    isSafeDigCourseSelected(course) {
      return this.safedigSelectedCourses.some((c) => c.id === course.id);
    },
    toggleSafeDigCourse(course) {
      const i = this.safedigSelectedCourses.findIndex((c) => c.id === course.id);
      if (i > -1) {
        this.safedigSelectedCourses.splice(i, 1);
      } else {
        this.safedigSelectedCourses.push(course);
      }
    },
    async submitSafeDigAssignCourses() {
      if (!this.safedigSelectedCourses.length) return;
      this.safedigAssigning = true;
      const courses = this.safedigSelectedCourses.map((c) => c.id);
      try {
        const { data } = await this.$http.post(
          'employees/safedig/assign-courses-without-payment',
          { courses }
        );
        const assigned = data.assigned || [];
        const skipped = data.skipped || [];
        let html = `<p class="text-left mb-2">${data.message || 'Done.'}</p>`;
        if (assigned.length) {
          html += '<p class="text-left font-weight-bold mb-1">Added</p><ul class="text-left pl-3">';
          assigned.forEach((a) => {
            html += `<li>${a.name}</li>`;
          });
          html += '</ul>';
        }
        if (skipped.length) {
          html += '<p class="text-left font-weight-bold mb-1 mt-2">Not added</p><ul class="text-left pl-3">';
          skipped.forEach((s) => {
            html += `<li><strong>${s.name}</strong> — ${s.message}</li>`;
          });
          html += '</ul>';
        }
        await Swal.fire({
          title: assigned.length ? 'Success' : 'Could not add courses',
          html,
          icon: assigned.length ? 'success' : 'info',
          confirmButtonText: 'OK',
        });
        this.safedigAddCourseModal = false;
        if (assigned.length) {
          this.fetchData();
        }
      } catch (error) {
        const msg =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Something went wrong. Please try again.';
        Swal.fire({
          title: 'Error',
          text: msg,
          icon: 'error',
        });
      } finally {
        this.safedigAssigning = false;
      }
    },
    // NEW: Get quantity for a specific course
    getQuantity(courseId) {
      return this.selectedSpecialCourseIDsAndUsers[courseId] || 1;
    },

    // NEW: Increase quantity
    increaseQuantity(courseId) {
      const currentQuantity = this.getQuantity(courseId);
      console.log("Current Quantity:", currentQuantity);
      const newQuantity = parseInt(currentQuantity) + 1;
      console.log("New Quantity:", newQuantity);
      let update = this.updateSpecialCourseQuantity(courseId, newQuantity);
      console.log("Update:", update);
    },

    // NEW: Decrease quantity
    decreaseQuantity(courseId) {
      const currentQuantity = this.getQuantity(courseId);
      if (currentQuantity > 1) {
        const newQuantity = currentQuantity - 1;
        this.updateSpecialCourseQuantity(courseId, newQuantity);
      }
    },

    // NEW: Update quantity from input (with debounce)
    updateQuantity(courseId, value) {
      // Clear existing timer
      if (this.quantityUpdateTimer) {
        clearTimeout(this.quantityUpdateTimer);
      }

      // Set new timer for debounced API call
      this.quantityUpdateTimer = setTimeout(() => {
        this.validateAndUpdateQuantity(courseId, value);
      }, 500); // 500ms debounce
    },

    // NEW: Validate and update quantity
    validateAndUpdateQuantity(courseId, value) {
      let quantity = parseInt(value);

      // Validation
      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      } else if (quantity > 9999) {
        quantity = 9999;
      }

      this.updateSpecialCourseQuantity(courseId, quantity);
    },

    // NEW: Update special course quantity and call API
    updateSpecialCourseQuantity(courseId, quantity) {
      // Update local state
      this.$set(this.selectedSpecialCourseIDsAndUsers, courseId, quantity);

      // Call API to recalculate pricing
      this.recalculatePricing();
    },

    // NEW: Recalculate pricing (debounced API call)
    async recalculatePricing() {
      try {
        const response = await this.$http.post("calculate_price", {
          courses: this.selectedCourses,
          courseIds: this.selectedCourses.filter(course => course.is_discounted_course === 1).map(course => course.id),
          specialCourses: this.selectedSpecialCourseIDsAndUsers,
          type: this.forEmps ? "other" : "self",
          user_id: this.user_id,
          company_id: this.company_id,
        });

        this.employeeCount = response.data.employee_count;
        this.perMonthCost = response.data.total;
        this.perYearCost = response.data.perYearCost;

         this.baseCourseSummary = response.data.base_courses;
        this.specialCourseSummary = response.data.special_courses;



        // Reset promo code if applied (since pricing changed)
        if (this.promoCodeApplied) {
          this.promoCodeApplied = false;
          this.promo_code = "";
          this.discount_percentage = 0;
        }

      } catch (error) {
        console.error('Error recalculating pricing:', error);
        if (error.response && error.response.status === 422) {
          Swal.fire({
            title: "Error!",
            text: error.response.data.message,
            icon: "error",
          });
        }
      }
    },
    selectPurchaseType(type) {
      this.showPurchaseTypeSelection = false;
      this.showCourseList = true;
      this.showCourseDetails = false;
      this.showCheckoutModal = false;
      this.showPaymentWindow = false;
      this.showEmpListModal = false;
      // Reset key data
      this.selectedCourses = [];
      this.selectedSpecialCourseIDsAndUsers = {};
      this.courseFilters = {};
      this.courseList = [];
      this.searchQuery = '';
      this.selectAll = false;
      this.selectedEmployees = [];
      this.promo_code = '';
      this.discount_percentage = 0;
      this.promoCodeApplied = false;
      if (type === 'employees') {
        this.forEmps = true;
        this.type = "other";
      } else {
        this.forEmps = false;
        this.type = "self";
      }
      this.listOfCourses();
    },
    backToPurchaseTypeSelection() {
      this.showCourseList = false;
      this.showPurchaseTypeSelection = true;
      this.forEmps = false;
      this.type = "";
    },
    applyPromoCode() {
      // this.loading = true;
      let data = {
        monthlyAmount: this.perMonthCost,
        yearlyAmount: this.perYearCost,
        locationAmount: "",
        userAmount: "",
        promocode: this.promo_code,
      };
      this.$http
        .post("promocode/apply_promocode", data)
        .then((resp) => {
          this.promoCodeApplied = true;
          this.perMonthCost = resp.data.final_amount_monthly;
          this.discount_percentage = resp.data.discount_percentage;
          this.perYearCost = resp.data.final_amount_yearly;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            Swal.fire({
              title: "Error",
              text: "Invalid Promo Code",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          } else {
            Swal.fire({
              title: "Network Error",
              text: "Please check your internet connection and try again",
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          }
        });
    },
    onPlanTypeChange() {
      this.isMonthly = this.pricingType === 'monthly';
      this.isYearly = this.pricingType === 'yearly';
    },
    twoDecimalFunction(value) {
      const number = parseFloat(value);
      if (isNaN(number)) return '0.00';
      return number.toFixed(2);
    },
    handleScroll(event) {
      const bottomReached =
        event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 20;

      if (bottomReached) {
        this.listOfCourses();
      }
    },
    applyFilter(val) {
      this.selectedRole = val;
    },
    toggleAllEmployees() {
      if (this.selectAll) {
        this.selectedEmployees = [...this.FilterlistEmployee]; // Select all employees
      } else {
        this.selectedEmployees = []; // Deselect all employees
      }
    },
    // purchaseModal(){
    //   this.purchaseNewCourseModal=true;
    // this.$nextTick(() => {
    //   if (this.$refs.stripeCard) {
    //     this.$refs.stripeCard.unmount();
    //     this.$refs.stripeCard.mount();
    //   }
    // });
    // this.listOfCourses();
    // this.listOfEmployees();
    // },
    //   loadStripe() {
    //   this.$nextTick(() => {
    //     if (this.$refs.elementRef) {
    //       console.log("Stripe Element Reloaded:", this.$refs.elementRef);
    //     }
    //   });
    // },
 purchaseModal() {
    this.purchaseNewCourseModal = true;

    // reset all steps
    this.showCourseList = false;
    this.showCourseDetails = false;
    this.showCheckoutModal = false;
    this.showPaymentWindow = false;
    this.showEmpListModal = false;

    if (this.hot_user !== 'company-admin') {
      // non-admins go straight to “self” course list
      this.type = 'self';
      this.forEmps = false;               // if you use this flag anywhere
      this.showPurchaseTypeSelection = false;
      this.showCourseList = true;
    } else {
      // admins still pick “self” vs “employees”
      this.showPurchaseTypeSelection = true;
      this.showCourseList            = false;
    }

    // re-mount stripe card if needed…
    this.$nextTick(() => {
      if (this.$refs.stripeCard) {
        this.$refs.stripeCard.unmount()
        this.$refs.stripeCard.mount()
      }
    });

    // load your paginated list
    if(this.hot_user!='company-admin'){
      this.listOfCourses();
    }
    // this.listOfEmployees();
  },
    paymentClicked(card, address) {
          if (!address.address?.trim() ||
        !address.city?.trim() ||
        !address.state?.trim() ||
        !address.zipcode?.trim()
    ) {
      Swal.fire({
        title: 'Missing Information',
        text: 'Please fill out Address, City, State and Zipcode before continuing.',
        icon: 'warning',
      });
      return;   // stop here if any field is empty
    }
      this.loading = true;

      // type condition of self or employee
      let payment = {
        payment_type: "payByEmployee",
        cardholder_street_address: "",
        cardholder_zip: "",
        cardholder_city: "",
        cardholder_state: "",
        transaction_amount: "",
        token: card.token,
        card_number: card.cardNumber,
        card_exp_date: card.expire,
      };
      payment.cardholder_state = address.state;
      payment.cardholder_street_address = address.address;
      payment.cardholder_zip = address.zipcode;
      payment.cardholder_city = address.city;
      payment.transaction_amount = this.calculateTotalCost();



      this.formDataVal.payment = payment;
      // Merge selectedCourses IDs and specialCourses IDs, ensuring uniqueness
      const selectedCourseIds = this.selectedCourses.map(course => course.id);
      const specialCourseIds = Object.keys(this.selectedSpecialCourseIDsAndUsers).map(id => Number(id));
      const allCourseIds = Array.from(new Set([...selectedCourseIds, ...specialCourseIds]));
      this.formDataVal.selectedCourses = allCourseIds;
      this.formDataVal.specialCourses = this.selectedSpecialCourseIDsAndUsers;
      this.formDataVal.user_id = this.user_id;
      this.formDataVal.company_id = this.company_id;
      // this.formDataVal.orignal_amount = this.orignalCost;
      // this.formDataVal.actual_amount = this.discountedCost;
      this.formDataVal.orignal_amount = this.isMonthly ? this.perMonthCost : this.perYearCost;
      this.formDataVal.actual_amount = this.isMonthly ? this.perMonthCost : this.perYearCost;
      this.formDataVal.pay_by_employee_dicount = this.is_payByEmployeeDiscount;
      this.formDataVal.selectedEmployees = this.selectedEmployees.map(emp => emp.id);
      this.formDataVal.type = this.type;

      this.$http
        .post("/purchase/self", this.formDataVal)
        .then((resp) => {
          Swal.fire({
            title: "Success!",
            html: `Amount Paid Sucessfully.`,
            icon: "success",
            confirmButton: "btn btn-success",
            confirmButtonText: "Ok",
          });
          this.loading = false;
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong!",
              icon: "error",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tokenCreated(token) {
      console.log("Stripe Token:", token);

      if (!token) {
        console.error("Stripe token generation failed!");
        return;
      }
      console.log("Stripe Token:", token);
      this.card.token = token;
    },
    backToCheckout() {
      this.showCheckoutModal = true;
      this.showPaymentWindow = false;
    },
    basedOnEmployee(price) {
      if (this.selectedEmployees.length === 0) return (parseFloat(price) * 1).toFixed(2);

      return (parseFloat(price) * this.selectedEmployees.length).toFixed(2);
    },
    calculateTotalCost() {
      return this.selectedCourses.reduce((total, course) => {
        return total + parseFloat(this.basedOnEmployee(course.cost));
      }, 0).toFixed(2);
    },

    showPaymentOption() {
      if (this.address == "" && this.zipcode == "") {
        this.addressAvailble = false;
      }
      this.showPaymentWindow = true;
      this.showCheckoutModal = false;
      this.showCourseDetails = false;
      this.showCourseList = false;
      this.showPaymentWindow = false;
      this.$nextTick(() => {
        this.showPaymentWindow = true;
        this.$nextTick(() => {
          if (this.$refs.stripeCard) {
            this.$refs.stripeCard.unmount();
            this.$refs.stripeCard.mount();
          }
        });
      });
    },
    //  async purchaseClick(val) {
    //     if(this.selectedCourses.length < 1 ){
    //       return Swal.fire({
    //           title: "Error!",
    //           text: `Please Select atleast one course`,
    //           icon: "error",
    //           confirmButtonClass: "btn",
    //           confirmButtonColor: "#E0E0E0",
    //           confirmButtonText: "OK",
    //         })
    //     }
    //      this.type = val === 1 ? "self" : "other";
    //     if(val==1){
    //       // this.selectedEmployees=[];
    //       this.showCheckoutModal = true;
    //     }
    //     else if (val==0){
    //       this.showCheckoutModal = true;
    //       this.forEmps = true;
    //       // this.showEmpListModal=true;
    //     }
    //     this.showCourseDetails = false;
    //     this.showCourseList = false;
    //     await this.pricing();

    //   },
    async purchaseClick(val) {
      if (this.selectedCourses.length < 1) {
        return Swal.fire({
          title: "Error!",
          text: `Please Select atleast one course`,
          icon: "error",
          confirmButtonClass: "btn",
          confirmButtonColor: "#E0E0E0",
          confirmButtonText: "OK",
        });
      }

      // The type is already set in selectPurchaseType method
      if (this.type === "other") {
        this.showCheckoutModal = true;
        this.forEmps = true;
      } else {
        this.showCheckoutModal = true;
      }

      this.showCourseDetails = false;
      this.showCourseList = false;
      await this.pricing();
    },
    pricing() {
      this.$http.post("calculate_price", {
        courses: this.selectedCourses,
        courseIds: this.selectedCourses.filter(course => course.is_discounted_course === 1).map(course => course.id),
        specialCourses: this.selectedSpecialCourseIDsAndUsers,
        type: this.type,
        user_id: this.user_id,
        company_id: this.company_id,
      }).then((resp) => {
        if (this.originalMonthlyPrice === 0) {
          this.originalMonthlyPrice = resp.data.total;
        }
        if (this.originalYearlyPrice === 0) {
          this.originalYearlyPrice = resp.data.perYearCost;
        }
        this.employeeCount = resp.data.employee_count,
          this.perMonthCost = resp.data.total;
        this.perYearCost = resp.data.perYearCost;


         this.baseCourseSummary = resp.data.base_courses;
        this.specialCourseSummary = resp.data.special_courses;

      })
        .catch((error) => {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong!",
              icon: "error",
            });
          }
        });
    },
    backToEmpList() {
      this.showEmpListModal = true;
      this.showCourseDetails = false;
      this.showCheckoutModal = false;
      this.showCourseList = false;
    },
    showCheckoutModalEmps() {
      if (this.selectedEmployees.length < 1) {
        return Swal.fire({
          title: "Error!",
          text: `Please Select atleast one Employee`,
          icon: "error",
          confirmButtonClass: "btn",
          confirmButtonColor: "#E0E0E0",
          confirmButtonText: "OK",
        })
      }
      this.showCourseDetails = false;
      this.showCourseList = false;
      this.showEmpListModal = false;
      this.showCheckoutModal = true;

    },
    async showCourseDetailsView(course, val = false) {
      this.fromhome = val;
      this.showSingleCourse = course;
      this.showCourseDetails = true;
      this.showCourseList = false;
      this.showCheckoutModal = false;
    },
    async showCourseDetailsView1(course, fromCheckout = false) {
      this.fromhome = !fromCheckout; // optional logic
      this.openedFromCheckout = fromCheckout; // 👈 track if coming from checkout

      this.showSingleCourse = course;
      this.showCourseDetails = true;

      this.showCourseList = false;
      this.showCheckoutModal = false;
    },
    showListView() {
      this.showCourseDetails = false;

      // 👇 Decide where to go back
      if (this.openedFromCheckout) {
        this.showCheckoutModal = true;
      } else {
        this.showCourseList = true;
      }

      this.openedFromCheckout = false; // reset
    },
    backToCouse() {
      this.showCourseList = true;
      this.showEmpListModal = false;
      this.showCourseDetails = false;
      this.showCheckoutModal = false;
    },
    showEmpScreen() {
      this.showEmpListModal = true;
      this.showCourseDetails = false;
      this.showCheckoutModal = false;
      this.showCourseList = false;

    },
    showListView() {
      if (this.fromhome) {
        this.showCourseList = true;
        this.showEmpListModal = false;
        this.showCheckoutModal = false;
        this.showSingleCourse = "";
        this.showCourseDetails = false;
        return;
      }
      this.fromhome = false;
      if (this.selectedEmployees.length != 0) {

        this.showCourseList = false;
        this.showEmpListModal = false;
        this.showCheckoutModal = true;

      } else {

        this.showEmpListModal = false;
        this.showCheckoutModal = true;
        this.showCourseList = false;
      }
      this.showSingleCourse = "";
      this.showCourseDetails = false;
      // this.showCheckoutModal = false;
      // this.showEmpListModal=false;
    },
    // showListViewBack() {
    //   if(this.selectedEmployees.length!=0){

    //     this.showCourseList = false;
    //     this.showEmpListModal=true;

    //   }else{

    //     this.showEmpListModal=false;
    //     this.showCourseList = true;
    //     this.forEmps = false;
    //   }
    //   this.promoCodeApplied = false;
    //   this.promo_code = "";
    //   this.discount_percentage = 0;
    //   this.showSingleCourse = "";
    //   this.showCourseDetails = false;
    //   this.showCheckoutModal = false;
    //   // this.purchaseClick();
    //   this.pricing();
    //   // this.showEmpListModal=false;
    // },
    showListViewBack() {
      if (this.selectedEmployees.length != 0) {
        this.showCourseList = false;
        this.showEmpListModal = true;
      } else {
        this.showEmpListModal = false;
        this.showCourseList = true;
        // this.forEmps = false;
      }
      this.promoCodeApplied = false;
      this.promo_code = "";
      this.discount_percentage = 0;
      this.showSingleCourse = "";
      this.showCourseDetails = false;
      this.showCheckoutModal = false;
      this.pricing();
    },
    isCourseSelected(course) {
      return this.selectedCourses.some((selected) => selected.id === course.id);
    },
    // toogleCourse(course) {

    //   const index = this.selectedCourses.findIndex(
    //     (selected) => selected.id === course.id
    //   );
    //   if (index > -1) {
    //     this.selectedCourses.splice(index, 1);
    //   } else {
    //     this.selectedCourses.push(course);
    //   }
    //   this.empTotalCost = this.selectedCourses
    //     .reduce((total, course) => total + course.cost, 0)
    //     .toFixed(2);
    // },


    //  async toogleCourse(course) {
    //     const index = this.selectedCourses.findIndex(
    //       (selected) => selected.id === course.id
    //     );

    //     // If already selected, remove it
    //     if (index > -1) {
    //       this.selectedCourses.splice(index, 1);

    //       // Also remove from specialCourse mapping if present
    //       if(this.forEmps){

    //       }
    //       if (course.is_discounted_course !== 1) {
    //         delete this.selectedSpecialCourseIDsAndUsers[course.id];
    //         this.specialCourseName = "";
    //         this.showusermodel = false;
    //         this.courseToAssignUsers = "";
    //         this.usersofSpecialCourse = 0; // Reset previous input
    //         //  this.selectedCourses.push(course);


    //       }

    //       if (this.selectedCourses.length === 0 && Object.keys(this.selectedSpecialCourseIDsAndUsers).length === 0) {
    //         this.showCheckoutModal = false;
    //         this.purchaseNewCourseModal = true;
    //         this.showCourseList = true;
    //       }
    //     } else {
    //       // If it's a discounted (special) course, ask for user input via modal
    //       if (course.is_discounted_course !== 1) {
    //         this.specialCourseName = course.name;
    //         this.showusermodel = true;
    //         this.courseToAssignUsers = course;
    //         this.usersofSpecialCourse = 0; // Reset previous input
    //         return; // Stop here and wait for user input
    //       }
    //       // If regular course, just add it
    //       this.selectedCourses.push(course);
    //     }
    //       await this.$http.post("calculate_price", {
    //       courses: this.selectedCourses,
    //       courseIds: this.selectedCourses.filter(course => course.is_discounted_course === 1).map(course => course.id),
    //       specialCourses : this.selectedSpecialCourseIDsAndUsers,
    //       type: this.type,
    //       user_id: this.user_id,
    //       company_id: this.company_id,
    //       }).then((resp) => {
    //        this.employeeCount = resp.data.employee_count,
    //        this.perMonthCost = resp.data.total;
    //        this.perYearCost = resp.data.perYearCost;

    //       })
    //       .catch((error) => {
    //         if (error.response.status === 422) {
    //           return Swal.fire({
    //             title: "Error!",
    //             text: error.response.data.message,
    //             icon: "error",
    //           });
    //         } else {
    //           Swal.fire({
    //             title: "Error!",
    //             text: "Something went wrong!",
    //             icon: "error",
    //           });
    //         }
    //       });



    //     // this.recalculateTotal();
    //   },
    async toogleCourse(course) {
      const isSelfOrEmp = this.type === 'self' || !this.forEmps;
      console.log("Course:", course);
      console.log("isSelfOrEmp:", isSelfOrEmp);
      const index = this.selectedCourses.findIndex(
        (selected) => selected.id === course.id
      );

      // Remove course if already selected
      if (index > -1) {
        console.log("Removing course:", course.name);
        this.selectedCourses.splice(index, 1);

        if (!isSelfOrEmp && course.is_discounted_course !== 1) {
          console.log("Removing from special course mapping:", course.id);
          delete this.selectedSpecialCourseIDsAndUsers[course.id];
          this.specialCourseName = "";
          this.showusermodel = false;
          this.courseToAssignUsers = "";
          this.usersofSpecialCourse = 0;
        }

        if (
          this.selectedCourses.length === 0 &&
          Object.keys(this.selectedSpecialCourseIDsAndUsers).length === 0
        ) {
          console.log("No courses selected, resetting modals");
          this.showCheckoutModal = false;
          this.purchaseNewCourseModal = true;
          this.showCourseList = true;
        }
      } else {
        console.log("Adding course:", course.name);
        // If special course flow disabled, or it's a discounted course
        if (isSelfOrEmp || course.is_discounted_course === 1) {
          console.log("Adding to selected courses:", course.name);
          this.selectedCourses.push(course);
        } else {
          // Show special course modal for user input
          console.log("Showing special course modal for:", course.name);
          this.specialCourseName = course.name;
          this.showusermodel = true;
          this.courseToAssignUsers = course;
          this.usersofSpecialCourse = 0;
          return; // Wait for user input
        }
      }

      // Handle price calculation here directly
      try {
        const response = await this.$http.post("calculate_price", {
          courses: this.selectedCourses,
          courseIds: this.selectedCourses
            .filter((course) => course.is_discounted_course === 1)
            .map((course) => course.id),
          specialCourses: isSelfOrEmp ? {} : this.selectedSpecialCourseIDsAndUsers,
          type: this.type,
          user_id: this.user_id,
          company_id: this.company_id,
        });

        this.employeeCount = response.data.employee_count;
        this.perMonthCost = response.data.total;
        this.perYearCost = response.data.perYearCost;


        this.baseCourseSummary = response.data.base_courses;
        this.specialCourseSummary = response.data.special_courses;
      } catch (error) {
        const message =
          error.response?.status === 422
            ? error.response.data.message
            : "Something went wrong!";
        Swal.fire({
          title: "Error!",
          text: message,
          icon: "error",
        });
      }
    },



    removePromoCode() {
      this.promoCodeApplied = false;
      this.promo_code = "";
      this.discount_percentage = 0;
      this.perYearCost = this.originalYearlyPrice;
      if (this.originalMonthlyPrice) {
        this.perMonthCost = this.originalMonthlyPrice;
      }
      if (this.originalYearlyPrice) {
        this.perYearCost = this.originalYearlyPrice;
      }
      this.pricing();
    },
    // Call this when user confirms special course users count in modal
    // async confirmSpecialCourseUsers() {
    //   if (this.usersofSpecialCourse > 0 && this.courseToAssignUsers) {
    //     const course = this.courseToAssignUsers;
    //     this.selectedCourses.push(course);
    //     this.selectedSpecialCourseIDsAndUsers[course.id] = this.usersofSpecialCourse;
    //     // this.recalculateTotal();
    //   }

    //   this.showusermodel = false;
    //   this.courseToAssignUsers = null;
    //   this.usersofSpecialCourse = 0;
    //   await this.pricing();

    // },
    // new ...
    async confirmSpecialCourseUsers() {
    if (this.usersofSpecialCourse > 0 && this.courseToAssignUsers) {
     // add the special course + its user-count
      this.selectedCourses.push(this.courseToAssignUsers);
      this.$set(
        this.selectedSpecialCourseIDsAndUsers,
        this.courseToAssignUsers.id,
        this.usersofSpecialCourse
      );

      // reset modal
      this.showusermodel       = false;
      // ③ FORCE the purchase‐modal lock back on
    this.$nextTick(() => {
      document.body.classList.add('modal-open');
    });
      this.courseToAssignUsers = null;
      this.usersofSpecialCourse = 0;

      // **immediately** re-price & update summary
      await this.pricing();
    }
  },


    toogleEmp(emp) {
      const index = this.selectedEmployees.findIndex(
        (selected) => selected.id === emp.id
      );
      if (index > -1) {
        this.selectedEmployees.splice(index, 1);
      } else {
        this.selectedEmployees.push(emp);
      }
      // this.empTotalCost = this.selectedCourses
      //   .reduce((total, course) => total + course.cost, 0)
      //   .toFixed(2);
    },
    isEmployeeSelected(emp) {
      return this.selectedEmployees.some((selected) => selected.id === emp.id);
    },
    listOfEmployees() {
      this.$http
        .post("list/emp", {
          company_id: this.company_id
        })
        .then((response) => {
          this.empList = response.data;
          this.empListCopy = response.data;
        })
        .catch((error) => {
          console.log("API failed for loading progress data");
        });
    },
    // listOfCourses() {
    //   this.$http
    //     .post("list/purchase-courses")
    //     .then((response) => {
    //       this.listCourses = response.data;
    //     })
    //     .catch((error) => {
    //       console.log("API failed for loading progress data");
    //     });
    // },
    listOfCourses(reset = false) {
      if (this.isLoading || (this.lastPage && this.page > this.lastPage)) return;

      this.isLoading = true;

      const requestData = {
        page: this.page,
        limit: 10,
        search: this.searchQuery,
        company_id: this.company_id,
        user_role : this.hot_user,
        for_emps: this.forEmps, // means for company ...
      };

      this.$http
        .post("list/purchase-courses", requestData)
        .then((response) => {
          const res = response.data;

          if (reset) {
            this.listCourses = res.data;
          } else {
            this.listCourses.push(...res.data);
          }

          this.lastPage = res.last_page;
          this.page += 1;
          this.isLoading = false;
        })
        .catch(() => {
          console.log("API failed for loading progress data");
          this.isLoading = false;
        });
    },



    showOpen() {
      this.is_open_show = true;
      this.is_expired = false;
      this.is_failed = false;
      this.is_passed = false;
      this.fetchData();
    },
    showExpired() {
      this.is_open_show = false;
      this.is_expired = true;
      this.is_failed = false;
      this.is_passed = false;
      this.fetchData();
    },
    showPassed() {
      this.is_open_show = false;
      this.is_expired = false;
      this.is_failed = false;
      this.is_passed = true;
      this.fetchData();
    },
    showFailed() {
      this.is_open_show = false;
      this.is_expired = false;
      this.is_failed = true;
      this.is_passed = false;
      this.fetchData();
    },
    folderProgressData() {
      this.$http
        .get("employees/employeeCourseFolderProgress")
        .then((response) => {
          this.folderProgress = response.data;
        })
        .catch((error) => {
          console.log("API failed for loading progress data");
        });
    },
    async PayCourse(row, type) {
      if (type === 'purchase') {
        this.discountedCost = this.calculateTotalCost();
        this.orignalCost = this.calculateTotalCost();

        if (this.selectedEmployees.length === 0) {
          try {
            let response = await this.$http.post("checkCourseActive", {
              course_id: this.selectedCourses.map(course => course.id),
              employee_id: this.selectedEmployees.map(emp => emp.id),
              company_id: this.company_id,
            });

            if (response.data.error) {
              // Courses with active certificates
              const message = response.data.message;

              const result = await Swal.fire({
                title: "Active Certificate Found!",
                text: message + " Do you still want to proceed with the purchase?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn",
                cancelButtonClass: "btn greybtn",
                confirmButtonColor: "#E0E0E0",
                cancelButtonColor: "",
                confirmButtonText: "Yes, Proceed",
                cancelButtonText: "No, Cancel"
              });

              if (!result.isConfirmed) {
                return; // Exit if user cancels
              }
            }

            // Proceed to show payment window
            this.showPaymentWindow = true;
            this.showCheckoutModal = false;

          } catch (error) {
            Swal.fire({
              title: "Error",
              text: "Failed to check active certificates. Please try again.",
              icon: "error"
            });
          }
        } else {
          // Proceed to show payment window
          this.showPaymentWindow = true;
          this.showCheckoutModal = false;
        }
        return;
      }
      this.discountedCost = row.discountedCost;
      this.orignalCost = row.course_cost;
      this.formData = {
        employee_id: this.user_id,
        company_id: this.company_id,
        course_id: row.id,
        orignal_amount: row.course_cost,
        pay_by_employee_dicount: this.is_payByEmployeeDiscount,
        actual_amount: this.discountedCost,
      };
      if (this.address == "" && this.zipcode == "") {
        this.addressAvailble = false;
      }
      this.payCourseModel = true;
    },
    takingCourse(course_id, due_date, is_2fa_required, playbtn) {
      if (is_2fa_required && this.is_authenticated == 0) {
        this.show2faModal = true;
      } else {
        if (this.editor !== "super-admin" && this.editor !== "sub-admin") {
          if (playbtn = true) {
            let data = {
              event: "Clicked on Take Course",
            };
            this.$http
              .post("user/add_activity", data)
              .then((resp) => {
              })
              .catch(function () {
              })
              .finally(() => (this.loading = false));
          }
        }
        this.$router.push(
          "/course_instructions?id=" + course_id + "&due_date=" + due_date
        );
      }
    },
    sendVerification() {
      this.loading = true;
      let data = {
        phone_no: "",
        chanel_type: this.verificationType,
      };
      if (this.newphonenumber) {
        data.phone_no = this.newphonenumber;
      } else {
        data.phone_no = this.phonenumber;
      }
      this.$http
        .post("twilio/sendOTP", data)
        .then((resp) => {
          this.askOtpModal = true;
          Swal.fire({
            title: "Success!",
            text: "Text sent to your phone number.",
            icon: "success",
          });
        })
        .catch(function (error) {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
    verifyOtp() {
      this.loading = true;
      let data = {
        phone_no: "",
        otp: this.otp,
      };
      if (this.newphonenumber) {
        data.phone_no = this.newphonenumber;
      } else {
        data.phone_no = this.phonenumber;
      }
      this.$http
        .post("twilio/VerifysendOTP", data)
        .then((resp) => {
          this.show2faModal = false;
          this.askOtpModal = false;
          Swal.fire({
            title: "Success!",
            text: "Verified successfully.",
            icon: "success",
          });
          this.fetchData();
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    formattedDate(data) {
      return moment(data).format("MM-DD-YYYY");
    },
    currentDate(duedate) {
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      if (currentDateWithFormat > duedate) {
        return true;
      } else {
        return false;
      }
    },
    fetchData() {
      this.loading = true;
      this.$http
        .post("employees/emp_courses_optimized", {
          search: this.searchQuery,
          employee_id: this.user_id,
          employee_status: this.employeeStatus,
        })
        .then((resp) => {
          this.tableData = [];
          let course_data = resp.data.courses;
          let employee_data = resp.data.employee;
          this.openCourses = resp.data.open_count;
          this.expiredCourses = resp.data.expired_count;
          this.failedCourses = resp.data.failed_count;
          this.passedCourses = resp.data.passed_count;

          this.address = employee_data.address;
          this.state = employee_data.state;
          this.city = employee_data.city;
          this.zipcode = employee_data.zipcode;

          this.is_authenticated = employee_data.is_2f_authenticated;
          this.phonenumber = employee_data.phone_num;

          let payby_employee = resp.data.company_pay_by_employee;
          if (payby_employee != null) {
            this.company_id = payby_employee.company_id;
            this.is_payByEmployeeOn = payby_employee.pay_employee_status;
            this.is_payByEmployeeDiscount = payby_employee.pay_employee_discount;
          }
          for (let data of course_data) {
            let obj = {
              id: data.course_id,
              course_name: data.name,
              course_length: data.length,
              course_cost: data.cost,
              img: data.image_url
                ? data.image_url
                : `placeholder.jpg`,
              discountedCost: "",
              completion_date: data.employee_course_date_completed,
              due_date: data.employee_course_due_date,
              course_status: data.employee_course_status,
              is_2fa_required: "",
              is_employee_paid: "",
              certificates: [],
              certificate_id: "",
            };

            if (data.employee_certiifcates) {
              obj.certificate_id = data.employee_certiifcates[0].id;
            }
            if (data.course_paid_status === 0) {
              obj.discountedCost =
                obj.course_cost - obj.course_cost * (this.is_payByEmployeeDiscount / 100);
              obj.is_employee_paid = false;
            } else {
              obj.is_employee_paid = true;
            }
            if (data.is_2fa_required === 1) {
              obj.is_2fa_required = true;
            } else {
              obj.is_2fa_required = false;
            }
            if (data.employee_certiifcates) {
              let certificate_data = data.employee_certiifcates;
              for (let certificate of certificate_data) {
                let certificates_obj = {
                  certificate_exp: certificate.certificate_expiration_date,
                  certificate_url: certificate.certificate_url,
                  is_coursefolder: certificate.is_coursefolder_certificate,
                  manual: certificate.manual,
                  is_proctored_exam: certificate.is_proctored_exam,
                };
                obj.certificates.push(certificates_obj);
              }
            }
            this.tableData.push(obj);
          }
        })
        .finally(() => (this.loading = false));
    },
    generatePreviewCertificate(id, user_id, certificate_id, is_coursefolder) {
      window.open(
        this.baseUrl +
        "/downloadCourseCertificate/preview/" +
        id +
        "/" +
        user_id +
        "/" +
        certificate_id +
        "/" +
        is_coursefolder
      );
    },
    generateDownloadCertificate(id, user_id, certificate_id, is_coursefolder) {
      window.open(
        this.baseUrl +
        "/downloadCourseCertificate/download/" +
        id +
        "/" +
        user_id +
        "/" +
        certificate_id +
        "/" +
        is_coursefolder
      );
    },
    previewManualCertificate(url) {
      window.open(url);
    },
    downloadManualCertificate(url) {
      window.open(url, "download");
    },
    getProctoredExamCertificate: function (certificateURL) {
      this.$http
        .post("course/proctored-exam-certificate", {
          certificateURL: certificateURL,
        })
        .then((resp) => {
          window.open(resp.data.certificate_url, "_blank");
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    changePhone() {
      this.changePhoneNum = true;
    },
    cancelPhone() {
      this.newphonenumber = "";
      this.changePhoneNum = false;
    },
    payClicked(cardData, addressData) {
      let payment = {
        payment_type: "payByEmployee",
        cardholder_street_address: "",
        cardholder_zip: "",
        cardholder_city: "",
        cardholder_state: "",
        transaction_amount: "",
        card_number: cardData.cardNumber,
        card_exp_date: cardData.expire,
      };
      if (addressData.address != "") {
        payment.cardholder_street_address = addressData.address;
        payment.cardholder_zip = addressData.zipcode;
        payment.cardholder_city = addressData.city;
        payment.cardholder_state = addressData.state;
      } else {
        payment.cardholder_street_address = this.address;
        payment.cardholder_zip = this.zipcode;
      }

      payment.transaction_amount = this.discountedCost.toFixed(2);

      this.formData.payment = payment;

      this.$http
        .post("course/pay_by_employee_submission", this.formData)
        .then((resp) => {
          Swal.fire({
            title: "Success!",
            html: `Amount Paid Sucessfully.`,
            icon: "success",
            confirmButton: "btn btn-success",
            confirmButtonText: "Ok",
          }).then((result) => {
            this.fetchData();
          });
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          }
        })
        .finally(() => (this.payCourseModel = false, this.showPaymentWindow = false));
    },
    acceptNumber() {
      var x = this.newphonenumber.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.newphonenumber = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
  },
  watch: {
    searchQuery(val) {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.page = 1;
        this.lastPage = null;
        this.listOfCourses(true); // reset list
      }, 500);
    },
    safedigSearchQuery() {
      clearTimeout(this.safedigSearchDebounce);
      this.safedigSearchDebounce = setTimeout(() => {
        this.safedigPage = 1;
        this.safedigLastPage = null;
        if (this.safedigAddCourseModal) {
          this.listOfCoursesSafeDig(true);
        }
      }, 400);
    },
    safedigAddCourseModal(open) {
      if (!open) {
        clearTimeout(this.safedigSearchDebounce);
        this.resetSafeDigAddCourseState();
      }
    }
  }

};
</script>
<style scoped>
.ignore-translation>>>.modal-dialog {
  max-width: 900px !important;
  /* Increased even more for wider cards */
  width: 95% !important;
}

.safedig-course-library-modal>>>.modal-dialog {
  max-width: 1040px !important;
}

.safedig-course-library-modal>>>.modal-body {
  padding: 1.25rem 1.5rem 1.5rem;
  --sd-accent: #3e7799;
  --sd-accent-soft: rgba(62, 119, 153, 0.14);
  --sd-text: #0f172a;
  --sd-muted: #475569;
  --sd-border: #e2e8f0;
  --sd-radius: 12px;
  --sd-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.05);
}

.safedig-modal-title {
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.safedig-picker-lead {
  margin: 0 0 1rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--sd-muted);
}

.safedig-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.safedig-search-field {
  margin-bottom: 1.25rem;
}

.safedig-search-inner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  background: #f8fafc;
  border: 1px solid var(--sd-border);
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.safedig-search-inner:focus-within {
  background: #fff;
  border-color: var(--sd-accent);
  box-shadow: 0 0 0 3px var(--sd-accent-soft);
}

.safedig-search-icon {
  color: #64748b;
  font-size: 0.9rem;
}

.safedig-search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 0.9375rem;
  color: var(--sd-text);
  appearance: none;
  -webkit-appearance: none;
}

.safedig-search-input::placeholder {
  color: #94a3b8;
}

.safedig-search-input:focus {
  outline: none;
}

.safedig-course-scroll {
  /* Tall enough for ~2 full grid rows (card image + body + gap + padding) */
  max-height: min(78vh, 640px);
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 -0.25rem;
  padding: 0.25rem;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.safedig-course-grid-outer {
  border-radius: var(--sd-radius);
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid var(--sd-border);
  padding: 1rem;
}

.safedig-course-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.65rem;
}

@media (min-width: 640px) {
  .safedig-course-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }
}

.safedig-course-card {
  display: block;
  text-align: left;
  background: #fff;
  border: 1px solid var(--sd-border);
  border-radius: 10px;
  box-shadow: var(--sd-shadow);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.safedig-course-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.04), 0 8px 20px rgba(15, 23, 42, 0.06);
}

.safedig-course-card:focus {
  outline: none;
}

.safedig-course-card:focus-visible {
  box-shadow: 0 0 0 3px var(--sd-accent-soft), var(--sd-shadow);
  border-color: var(--sd-accent);
}

.safedig-course-card--selected {
  border-color: var(--sd-accent);
  background: rgba(62, 119, 153, 0.06);
  box-shadow: 0 0 0 1px var(--sd-accent), 0 4px 14px rgba(62, 119, 153, 0.1);
}

.safedig-course-card__row {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.85rem 1rem;
  min-height: 3.25rem;
}

.safedig-course-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  background: var(--sd-accent-soft);
  color: var(--sd-accent);
}

.safedig-course-card__icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

.safedig-course-card__title {
  flex: 1;
  margin: 0;
  min-width: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--sd-text);
  letter-spacing: -0.01em;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.safedig-course-card__mark {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  color: #94a3b8;
  transition: color 0.2s ease, transform 0.2s ease;
}

.safedig-course-card__mark--on {
  color: var(--sd-accent);
}

.safedig-course-card__mark-svg {
  width: 22px;
  height: 22px;
  display: block;
}

.safedig-loading-row {
  display: flex;
  justify-content: center;
  padding: 1.25rem 0 0.5rem;
}

.safedig-empty-state {
  text-align: center;
  padding: 2.5rem 1.5rem 1.5rem;
}

.safedig-empty-state__title {
  margin: 0 0 0.35rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--sd-text);
}

.safedig-empty-state__hint {
  margin: 0;
  font-size: 0.875rem;
  color: var(--sd-muted);
}

.safedig-picker-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--sd-border);
}

.safedig-picker-footer__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.safedig-selection-pill {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sd-accent);
  background: var(--sd-accent-soft);
  border-radius: 999px;
}

@media (prefers-reduced-motion: reduce) {
  .safedig-search-inner,
  .safedig-course-card,
  .safedig-course-card__mark {
    transition: none;
  }
}

/* Purchase Type Selection Styles */
.purchase-type-selection {
  padding: 30px;
}

.purchase-type-container {
  max-width: 900px;
  /* Increased container width */
  margin: 0 auto;
}

.purchase-type-header h4 {
  color: #333;
  font-weight: 600;
  font-size: 1.5rem;
}

.purchase-type-header p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

/* Purchase Type Buttons Container */
.purchase-type-buttons .row {
  margin: 0 -15px;
  /* Adjust row margins */
}

.purchase-type-buttons .col-md-5 {
  flex: 0 0 48%;
  /* Make each column take 48% width instead of default */
  max-width: 48%;
  padding: 0 1%;
  /* Add small padding between cards */
}

/* Purchase Type Cards - Equal Size and Wider */
.purchase-type-card {
  box-shadow: 0 !important;
  cursor: pointer;
  transition: transform 0.2s ease;
  height: 100%;
  /* Ensure full height */
}



.purchase-card-hover {
  box-shadow: 0 !important;
  transition: all 0.3s ease;
  border: 2px solid #e9ecef !important;
  border-radius: 0 !important;
  min-height: 280px !important;
  /* Fixed height for equal sizing */
  max-height: 280px !important;
  /* Ensure consistent height */
  padding: 2.5rem 2rem !important;
  /* Increased padding */
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
}


.purchase-card-hover .card-body {
  box-shadow: 0 !important;

  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
  text-align: center !important;
  padding: 0 !important;
  /* Remove default card-body padding */
}

.purchase-icon {
  margin-bottom: 1.5rem !important;
  flex-shrink: 0;
  /* Prevent icon from shrinking */
}

.purchase-icon svg {
  width: 64px !important;
  height: 64px !important;
}

.card-title {
  color: #333;
  font-weight: 600;
  font-size: 1.3rem !important;
  /* Slightly larger title */
  margin-bottom: 1rem !important;
  flex-shrink: 0;
  /* Prevent title from shrinking */
  line-height: 1.3 !important;
}

.card-text {
  font-size: 1rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  flex-grow: 1 !important;
  /* Allow text to fill remaining space */
  display: flex !important;
  align-items: center !important;
  line-height: 1.4 !important;
}

/* Ensure equal spacing and alignment */
.purchase-type-buttons .row.justify-content-center {
  display: flex !important;
  justify-content: center !important;
  align-items: stretch !important;
  /* Make cards same height */
  gap: 2rem;
  /* Add gap between cards */
}

.quantity-selector-container {
  margin-top: 8px;
}

.quantity-selector {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  max-width: 120px;
}

.quantity-btn {
  background: #f8f9fa;
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6c757d;
}

.quantity-btn:hover:not(:disabled) {
  background: #FE672C;
  color: white;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-input {
  border: none;
  width: 56px;
  height: 32px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  background: white;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.quantity-input:focus {
  background: #f8f9fa;
}

/* Remove number input arrows */
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-input[type=number] {
  -moz-appearance: textfield;
}

.hover-highlight {
  transition: background-color 0.3s ease;
}

.hover-highlight:hover {
  background-color: #f0f0f0;
  /* Light grey */
  cursor: pointer;
}

.dash-card-box {
  /* margin-bottom: 20px; */
}

.no-border-card .card-footer {
  border-top: 0;
}

/* Add these styles to your CSS */
.stripe-card {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.StripeElement {
  height: 40px;
  padding: 10px 12px;
  width: 100%;
}


@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .empcoursesGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Course Name";
  }

  .empcoursesGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Due Date";
  }

  .empcoursesGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Lesson Status";
  }

  .empcoursesGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Estimated Time";
  }

  .empcoursesGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Action";
  }
}

.role-filter-drop-down {
  right: 0;
  top: 0;
  padding: 10px 20px
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #FE672C;
  color: #fff;
}

.course-status {
  color: #7C7B7B;
  font-size: 14px;
}

.course-status span:after {
  content: "";
  width: 12px;
  margin-left: 5px;
  height: 12px;
  display: inline-block;
  background: #139A1B;
  border-radius: 50%;
  position: relative;
  top: 1px;
}

.course-status span.active:after {
  background: #139A1B;
}

.course-status span.failed:after {
  background: #FFF600;
}

.course-status span.expired:after {
  background: #E83124;
}

.orange-loader {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(254, 103, 44, 0.2);
  /* Light orange border */
  border-top: 4px solid #FE672C;
  /* Your orange color */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
}

.course-title-hover {
  color: #333;
  /* Default text color */
  cursor: pointer;
  /* Makes it look clickable */
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.course-title-hover:hover {
  color: #FE672C;
  /* Hover color (adjust to your brand) */

}

.custom-button-width {
  width: 49%;
}

.custom-scrollable-modal {
  display: flex;
  flex-direction: column;
  height: 90vh; /* adjust height of modal */
  max-height: 90vh;
  overflow: hidden;
}

.modal-scroll-area {
  overflow-y: auto;
  padding: 20px;
  flex: 1;
  min-height: 0; /* fix for flexbox overflow */
}

</style>
